export const en = {
  Meta: {
    home: {
      title: "Create 100% Free & Elegant Digital Invitations | Elynk",
      description: "Create digital invitations easily on Elynk. Hundreds of elegant themes, automated WhatsApp broadcasts, and guest tracking. Fast, modern, and hassle-free!",
      keywords: [
        "digital invitation",
        "online wedding invitation",
        "elynk",
        "free invitation maker",
        "wedding website",
        "digital guestbook",
        "digital envelope",
        "automated whatsapp broadcast"
      ]
    },
    price: {
      title: "Digital Invitation Pricing Plans - Elynk.co",
      description: "Choose the best pricing plan for your digital invitations. Free forever plans available with full features and unlimited sharing."
    },
    theme: {
      title: "Elegant, Luxurious & Modern Digital Invitation Theme Catalog | Elynk",
      description: "Choose from hundreds of aesthetic digital invitation designs for weddings, circumcisions, or other events. Mobile-responsive, fast-loading, and always updated."
    },
    feature: {
      title: "Complete Digital Invitation Features | Elynk",
      description: "Complete features from automated WhatsApp broadcast, QR check-in guestbook, digital envelope, to flexible custom RSVP."
    },
    login: {
      title: "Sign In to Your Account | Elynk",
      description: "Sign in to your Elynk dashboard to manage and create your dream digital invitations."
    },
    register: {
      title: "Register New Account 100% Free | Elynk",
      description: "Create an Elynk account now and start creating professional digital invitations at zero cost."
    }
  },
  Common: {
    atau: "or",
    sebelumnya: "Previous",
    mengimport: "Importing...",
    opsi: "Options",
    kelola: "Manage",
    filter: "Filter",
    status: "Status",
    jenis_acara: "Event Type",
    cari: "Search",
    batal: "Cancel",
    simpan: "Save",
    loading: "Loading...",
    tidak_ada_hasil: "No results found",
    pilih: "Select",
    tutup: "Close",
    edit: "Edit",
    hapus: "Delete",
    tambah: "Add",
    lihat: "View",
    semua: "All",
    terbaru: "Newest",
    terlama: "Oldest",
    nama_az: "Name A-Z",
    pulihkan: "Restore",
    arsipkan: "Archive",
    reset_filter: "Reset Filter",
    reset: "Reset",
    preview: "Preview",
    kembali: "Back",
    titip_hadiah: "Send Gift",
    menyimpan: "Saving...",
    simpan_perubahan: "Save Changes",
    terdapat_kesalahan: "There are errors",
    muat_lebih_banyak: "Load More",
    tidak_ada_data: "No data available",
    tindakan: "Action",
    aksi: "Actions",
    tidak_ada_opsi: "No options available",
    masukkan: "Enter",
    pemilik_acara: "Event Owner",
    memuat_ucapan: "Loading greetings...",
    total_ucapan: "Total Greetings",
    tamu_undangan: "Invited Guest",
    total_ucapan_with_count: "Greetings ({total} Total Greetings)",
    ucapan: "Greetings & Prayers",
    total_ucapan_count: "{total} greetings",
    rsvp_ucapan: "RSVP & Greetings",
    ucapan_placeholder: "Write your wishes & prayers",
    nama_placeholder_ucapan: "Your name",
    sedang_dipilih: "Selected",
    lokasi_acara: "Event Location",
    map_lokasi_acara: "Event Location Map",
    pilih_kado_fisik: "Choose Physical Gift",
    pilih_kado_fisik_title: "Choose Physical Gift",
    gift_physical_hint: "Click the button below to send a physical gift to the event:",
    kirim: "Send",
    tutorial: "Tutorial",
    info_withdraw: "Event owner will receive realtime notification for withdraw",
    info_payment_success: "Payment Successful",
    info_payment_success_desc: "Thank you for your contribution! Your payment has been successfully processed. The event owner will receive a notification shortly.",
    info_payment_failed: "Payment Failed",
    info_payment_failed_desc: "Sorry, there was an issue processing your payment. Please try again or contact the event owner for more information.",
    info_payment_failed_desc_2: "Please try again or contact the event owner for more information",
    menutup_otomatis: "This tab will close automatically...",
    menutup_otomatis_dalam: "Closing automatically in",
    salin: "Copy",
    refresh: "Refresh",
    pilih_mode: "Select Mode",
    memuat_data: "Loading data...",
    hapus_data: "Delete Data?",
    menghapus: "Deleting...",
    ya_hapus: "Yes, Delete",
    memuat_data_tamu: "Loading Guest Data...",
    opsional: "Optional",
    detail: "Detail",
    memproses: "Processing...",
    sembunyikan: "Hide",
    tampilkan: "Show",
    ditampilkan: "Shown",
    disembunyikan: "Hidden",
    yakin_hapus_undangan: "Are you sure you want to delete the invitation",
    tindakan_permanen: "This action cannot be undone.",
    back: "Back",
    gift_registry_send_title: "Send a Gift to the Event Owner",
    gift_registry_send_description: "Choose a physical gift that will be delivered directly to the event owner.",
    gift_registry_select_physical_gift: "Choose Physical Gift",

    gift_registry_safe_trusted: "Safe & Trusted",
    gift_registry_delivered: "Gift Delivered to Recipient",
    gift_registry_special_memory: "Creates a Special Memory",
    wajib: "Required",
    selesai: "Completed",
    skip: "Skip",
    sesuaikan: "Customize",
    tidak_ada_style: "No style available",
    hadiah_tidak_tersedia: "Gift is not available.",
    copy: "Copy",
    nama: "Name",
    jumlah: "Amount",
    konfirmasi_via_whatsapp: "Confirm via WhatsApp",
    pagination: {
      page: "Page",
      of: "of",
      total: "Total",
      data: "Data",
      prev: "Prev",
      next: "Next"
    },
    update_rsvp: "You have already submitted your RSVP. To change your RSVP data, please click here.",
    berhasil_diaktifkan: "successfully activated",
    berhasil_dinonaktifkan: "successfully deactivated",
    edit_undangan: "Edit Invitation",
    belum_ada_data: "No data found",
    simpan_sebagai_duplikat: "Save as a duplicate",
    set_default: "Save as a default"
  },
  ThemePicker: {
    title: "Choose Invitation Theme",
    current_theme: "Current Theme:",
    update_latest: "Update Theme to Latest Version",
    reset_title: "Reset invitation theme?",
    reset_description: "The theme you are currently using will be updated to the latest version. This may cause layout adjustments in your invitation.",
    reset_action: "Reset Theme",
    resetting_action: "Resetting..."
  },
  DigitalEnvelope: {
    placeholder_amount: "Enter amount",
    full_name: "Full Name",
    email: "Email",
    whatsapp: "Whatsapp",
    greeting: "Greeting",
    helper_private_notification: "Not visible to public, for payment notifications",
    company_name: "PT Monly Aplikasi Finansial",
    company_address: "Jl. Gunung Batur, No.88x, Buleleng, Bali",
    company_email: "info@elynk.co",
    company_phone: "+6287888030598",
    cta_continue_payment: "Continue Payment",
    success_payment_created: "Payment created successfully",
    error_save_failed: "Failed to save changes. Please try again.",
    info_paragraph_start: "Digital Envelope allows guests to send cashless envelopes. Payments are automatically verified and the event owner will receive",
    info_paragraph_highlight: "notifications",
    info_paragraph_end: "in realtime via WhatsApp and email",
    how_it_works: "How Does It Work?",
    step1_title: "Guests Send Digital Gifts",
    step1_desc: "Guests can securely send monetary gifts directly through the digital invitation using available payment methods.",
    step2_title: "Real-Time Notifications",
    step2_desc: "The event host receives an instant notification the moment a digital envelope is sent.",
    step3_title: "Automated Records & Easy Withdrawals",
    step3_desc: "All received funds are automatically recorded in the system and can be withdrawn to your bank account at any time.",
    main_benefits: "Core Benefits",
    card1_title: "Real-Time Notifications",
    card1_desc: "Hosts are instantly informed of every incoming gift without the need to manually check their accounts.",
    card2_title: "Transparent Transaction History",
    card2_desc_1: "Every transaction is neatly recorded, complete with:",
    card2_li_1: "Sender's name",
    card2_li_2: "Time of transaction",
    card2_li_3: "Amount received",
    card2_desc_2: "Making it effortless for hosts to track and reconcile gifts.",
    card3_title: "Seamless Fund Withdrawals",
    card3_desc: "Accumulated funds can be easily and transparently withdrawn to your bank account according to our secure guidelines.",
    card4_title: "Secure & Transparent",
    card4_desc: "We implement advanced systems designed to maintain the highest level of security and transparency:",
    card4_li_1: "Every transaction is securely logged",
    card4_li_2: "Hosts have 24/7 access to their financial data",
    card4_li_3: "Withdrawal processes are strictly controlled",
    card5_title: "Perfectly Suited For",
    card5_li_1: "Weddings & family gatherings",
    card5_li_2: "Traditional ceremonies",
    card5_li_3: "Professional events",
    card5_li_4: "Events with guests attending from afar",
    card6_title: "Fully Integrated Ecosystem",
    card6_desc: "The Automated Digital Envelope connects directly with:",
    card6_li_1: "Custom RSVP management",
    card6_li_2: "Automated WhatsApp Broadcasts",
    card6_li_3: "Transaction & Notification Reports",
    card6_footer: "Everything is managed from one beautifully simple dashboard."
  },
  CustomRSVP: {
    section1_title: "Clear Attendance Status",
    section1_desc: "Every guest response is logged with absolute clarity, empowering you to:",
    section1_li_1: "Accurately track the exact number of expected guests",
    section1_li_2: "Monitor guest responses in real-time",
    section1_li_3: "Eliminate last-minute confusion leading up to the event",
    section2_title: "Guest Limits per Invitation",
    section2_desc: "With this feature, you can strictly <b>define the maximum number of plus-ones each guest is allowed to bring.</b><br/><span class='mt-2 block font-medium'>For example:</span>",
    section2_li_1: "Personal invitations: limit to 1-2 people",
    section2_li_2: "Family invitations: maximum according to their quota",
    section2_li_3: "Exclusive invitations: strictly no plus-ones allowed",
    section2_footer: "This feature is incredibly helpful for maintaining strict venue capacity control.",
    section3_title: "Why is a Flexible Custom RSVP Critical?",
    section3_desc_1: "Without a controlled RSVP system, organizers frequently face:",
    section3_li_1: "Guest counts exceeding the venue's capacity",
    section3_li_2: "Guests bringing unconfirmed plus-ones",
    section3_li_3: "Unpredictable and chaotic attendance data",
    section3_desc_2: "With our flexible Custom RSVP, you can effortlessly:",
    section3_li_4: "Keep event capacity perfectly aligned with your plan",
    section3_li_5: "Prevent unexpected overcrowding",
    section3_li_6: "Manage your guests with elegance and professionalism",
    section4_title: "Perfectly Suited For",
    section4_li_1: "Intimate weddings with highly restricted guest lists",
    section4_li_2: "Family events requiring session-based scheduling",
    section4_li_3: "Professional events demanding strict access control",
    section4_li_4: "Events constrained by strict venue capacity limits",
    section5_title: "Seamless Feature Integration",
    section5_desc: "Our flexible Custom RSVP connects instantly with:",
    section5_li_1: "Automated Event Reminders",
    section5_li_2: "QR Code Guest Book Check-in",
    section5_li_3: "Comprehensive Attendance Analytics",
    section5_footer: "All RSVP data flows securely through the platform to guarantee a flawlessly executed event."
  },
  Sidebar: {
    dashboard: "Digital Invitations",
    daftar_tema: "Themes List",
    inspirasi: "Inspiration",
    tutorial: "Tutorial",
    vendor: "Vendor",
    afiliator: "Affiliate",
    menu: "Menu",
    peluang: "Opportunities",
    profil: "Profile",
    preferensi: "Preference",
  },
  Auth: {
    keluar: "Sign out",
    keluar_proses: "Signing out...",
    send_otp_title: "Send Verification Code",
    send_otp_heading: "Account Verification",
    send_otp_desc: "Enter your email address to receive a verification OTP code.",
    email_label: "Email Address",
    email_required: "Please enter your email address first.",
    send_otp_btn: "Send OTP Code",
    verify_email_title: "Verify Email",
    verify_email_heading: "Email Verification",
    verify_email_desc: "We have sent a 6-digit code to your email",
    verify_btn: "Verify",
    verifying: "Verifying...",
    resend_code_now: "Resend code now",
    resending: "Resending...",
    resend_code_in: "Resend code in",
    otp_incomplete: "Please enter the complete 6-digit OTP code.",
    email_not_found: "Email not found.",
    verify_success: "Email verified successfully!",
    otp_resent: "A new OTP code has been sent to your email.",
    otp_invalid_or_expired: "Invalid or expired OTP code.",
    otp_resend_failed: "Failed to resend OTP code.",
  },
  Avatar_Dropdown: {
    profile: "Profile",
    ganti_password: "Change Password",
    logout: "Logout",
    pengaturan: "Settings"
  },
  Dashboard: {
    data_acara: "Event Data",
    tambah_acara: "Add Event",
    aktifkan_undangan: "Activate Invitation",
    edit_undangan: "Edit Invitation",
    preview_hasil: "Preview Result",
    pilih_tema: "Choose Theme",
    sebar_undangan: "Share Invitation",
    status_undangan: "Invitation Status",
    hapus_undangan: "Delete Invitation",
    belum_ada_data: "No Event Data Available",
    belum_ada_data_desc: "Click Add Event → Choose Event Type → Fill All Data → Click Save → Click Preview",
    id: "ID",
    total_acara: "Total Events",
    acara_aktif: "Active Events",
    acara_nonaktif: "Inactive Events",
    duplikat_undangan: "Duplicate Invitation",
    anda_akan_menduplikat: "You are about to duplicate the invitation",
    catatan_duplikat: "Note: The duplicated result will automatically be set to the",
    free: "Free",
    ya_duplikat: "Yes, Duplicate",
    acara_saya: "My Events",
    dibagikan_ke_saya: "Shared with Me",
    belum_ada_kolaborasi: "No Collaboration Yet",
    belum_ada_kolaborasi_desc: "Currently there are no invitations from others shared with your account.",
    semua_acara_ditampilkan: "All events have been displayed",
    akses_kolaborasi: "Collaboration Access",
    tanpa_judul: "Untitled",
    arsip: "Archive",
    arsip_kosong: "No Archived Events",
    arsip_kosong_desc: "Invitations you archive will appear here and can be restored at any time.",
    jenis_acara: "Event Type",
    paket: "Package",
    urutkan: "Sort By:"
  },

  WhatsAppShare: {
    frameTitle: "Share via WhatsApp",
    previewView: "Preview View:",
    tabs: {
      list: "List",
      wizard: "Wizard (Create Draft)",
      detail: "Sent Detail"
    },
    sandbox: {
      title: "Billing Top-up Limit",
      desc: "Integration of the WhatsApp API credit top-up gateway for DEBS agency is being prepared.",
      closeBtn: "Close Sandbox"
    },
    list: {
      title: "Share Via WhatsApp",
      subtitle: "Manage invitation delivery via WhatsApp. Choose a ready-to-use template, check limits, and send.",
      remainingLimit: "Remaining limit",
      unitMessage: "messages",
      btnTopup: "Add Limit",
      btnCreate: "+ Create WhatsApp Share Draft",
      tableTitle: "Drafts & Delivery History",
      tableSubtitle: "Drafts can be edited until you press send. Once sent, drafts cannot be modified.",
      pageSizePlaceholder: "10",
      searchPlaceholder: "Search draft...",
      noResults: "The draft you are looking for was not found.",
      emptyState: "No broadcast drafts have been created yet.",
      bulkSelect: "Selected",
      btnCancel: "Cancel",
      btnDeleteBulk: "Delete Draft",
      alertDelete: "Deleting {count} draft queue items.",
      columns: {
        name: "Draft Name",
        recipients: "Recipients",
        template: "Template",
        status: "Status",
        updated: "Last Modified",
        actions: "Actions"
      },
      statusType: {
        draft: "Draft",
        sent: "Sent",
        failed: "Partially Failed"
      },
      actionsBtn: {
        continue: "Continue",
        viewDetail: "View Detail"
      }
    },
    wizard: {
      defaultTitle: "New Share Draft",
      subtitle: "Create a new draft to distribute invitations via WhatsApp",
      btnSaveDraft: "Save as Draft",
      btnNext: "Next",
      steps: {
        step1: "Select Contacts",
        step2: "Select Template",
        step3: "Follow Up",
        step4: "Check Limit",
        step5: "Finalization & Delivery"
      }
    },
    recipient: {
      title: "Select Recipients",
      subtitle: "Determine which guests will receive this WhatsApp invitation message.",
      all: {
        title: "All Contacts",
        desc: "Send to all contacts who have a WhatsApp number.",
        badge: "8 contacts"
      },
      manual: {
        title: "Select Contacts",
        desc: "Select guests one by one from your contact list.",
        selectedText: "{count} of {total} contacts selected",
        searchPlaceholder: "Search name..."
      },
      label: {
        title: "By Label",
        desc: "Send to one or several labels at the same time.",
        selectedText: "{total} contacts from {count} labels will be sent",
        filterLabel: "Filter Label",
        allActive: "All Active Labels",
        unitLabel: "labels",
        unitContact: "contacts"
      },
      summary: {
        title: "{count} contacts will receive WhatsApp",
        desc: "All contacts with a valid WhatsApp number will be sent this invitation."
      }
    },
    template: {
      title: "Select Message Style Template",
      subtitle: "Choose the automated broadcast message writing style that fits best.",
      previewTitle: "Preview",
      noteLimit: "Note: 1 Message recipient requires 1 Limit",
      officialAccount: "Official Account",
      today: "TODAY",
      noCover: "No cover image"
    },
    limit: {
      title: "Check Delivery Limit",
      subtitle: "1 contact sent = 1 limit used. The limit you own can be used anytime, with no expiration date.",
      cards: {
        ownedTitle: "Owned Limit",
        ownedUnit: "messages available",
        needTitle: "Delivery Requirement",
        needUnitMsg: "messages needed",
        afterTitle: "Remaining After Send",
        afterUnit: "messages remaining",
        afterShortage: "insufficient quota"
      },
      comparison: "Requirement vs Your Limit",
      comparisonUnit: "of {total} messages",
      status: {
        successTitle: "Limit is sufficient",
        successDesc: "You have {owned} limit and need {need} for this shipment. Remaining after send: {rem} messages.",
        errorTitle: "Limit is insufficient",
        errorDesc: "Your requirement ({need}) exceeds the quota limit currently owned. Short of {short} more messages."
      },
      btnTopup: "Add Limit",
      footerNote: "Purchased limits can be used anytime, with no expiration date."
    },
    send: {
      title: "Review Before Sending",
      params: {
        recipients: "Recipients",
        template: "Template",
        channel: "Channel",
        remaining: "Remaining Limit After Send",
        unitContact: "contacts",
        unitMessage: "messages"
      },
      listTitle: "Recipient List ({count})",
      moreBadge: "+{count} more →",
      statusTitle: "Ready to send to {count} contacts",
      statusDesc: "WhatsApp messages will be sent one by one to avoid spam. The process takes about 2–3 minutes.",
      warningText: "Once sent, the draft cannot be edited or resent. Please make sure the message is correct.",
      btnSendMass: "Send Now",
      btnTestSend: "Test Send WhatsApp",
      alertTest: "Test message successfully sent to your WhatsApp number!"
    },
    followup: {
      autoTitle: "Automatic Follow Up",
      autoDesc: "Automatically resend messages to guests after invitation is sent — for RSVP confirmation and reminding guests who will attend. Set schedule & template for each type below.",
      rsvpTitle: "RSVP Follow Up",
      rsvpDesc: "Sent to guests who haven't filled out RSVP, so they confirm their attendance.",
      reminderTitle: "Follow Up Reminder",
      reminderDesc: "Sent to guests who have RSVP'd & confirmed attendance, as a reminder before the event.",
      previewTitle: "Message Preview",
      scheduleLabel: "Send Schedule",
      daysBefore: "H-",
      daysUnit: "days",
      sentBefore: "Sent {days} days before event ({date})",
      templateLabel: "Select Template",
      templates: {
        hangat: "Warm",
        hangatDesc: "Friendly & personal",
        singkat: "Brief",
        singkatDesc: "To the point",
        santai: "Casual",
        santaiDesc: "Friendly & light",
        detail: "Event Details",
        detailDesc: "Complete with info"
      },
      target: {
        rsvp: "Guests who haven't filled out RSVP",
        reminder: "Guests who have RSVP'd & confirmed attendance"
      },
      modalTitle: "Follow Up Settings",
      status: {
        active: "Active",
        inactive: "Inactive"
      }
    },
    detail: {
      subtitle: "Sent {date} · Template {tpl} · {count} contacts",
      btnExport: "Export CSV",
      cards: {
        total: "Total Sent",
        success: "Delivered",
        failed: "Failed",
        pending: "Pending",
        read: "Read"
      },
      tableTitle: "Status per Contact",
      tableSubtitle: "Detailed delivery history to each guest",
      filters: {
        all: "All",
        success: "Delivered",
        failed: "Failed",
        pending: "Pending",
        read: "Read"
      },
      columns: {
        contact: "CONTACT",
        phone: "WHATSAPP NUMBER",
        label: "LABEL",
        status: "STATUS",
        time: "TIME"
      },
      emptyState: "No contact history available yet.",
      noResults: "The contact you are looking for was not found."
    }
  },

  ShareViaEmail: {
    list: {
      title: "Share Via Email",
      subtitle: "Manage invitation delivery via email. Create a draft, adjust the message, then send it to your guests.",
      btnCreate: "Create Email Share Draft",
      tableTitle: "Drafts & Delivery History",
      tableSubtitle: "Drafts can be edited until you press send. Once sent, drafts cannot be modified.",
      searchPlaceholder: "Search draft…",
      emptyState: "No drafts yet.",
      unitContact: "contacts",
      tabs: {
        all: "All",
        draft: "Draft",
        sent: "Sent"
      },
      columns: {
        name: "Draft Name",
        recipients: "Recipients",
        template: "Template",
        status: "Status",
        updated: "Last Modified",
        actions: "Actions"
      },
      actionsBtn: {
        continue: "Continue",
        viewDetail: "View Detail"
      }
    },
    status: {
      draft: "Draft",
      sending: "Sending",
      pending: "Pending",
      sent: "Sent",
      partial: "Partially Failed",
      failed: "Failed"
    },
    wizard: {
      defaultTitle: "New Invitation Draft",
      subtitle: "Create a new draft to distribute invitations via email",
      btnSaveDraft: "Save as Draft",
      btnSaving: "Saving...",
      btnNext: "Next",
      stepLabel: "Step {n}",
      steps: {
        step1: "Select Contacts",
        step2: "Adjust Template",
        step3: "Follow Up",
        step4: "Finalize & Send"
      },
      toastDraftSaved: "Draft saved"
    },
    recipient: {
      title: "Select Recipients",
      subtitle: "Determine which guests will receive this email invitation.",
      contactField: "email address",
      all: {
        title: "All Contacts",
        desc: "Send to all contacts who have a {field}.",
        unitContact: "contacts"
      },
      manual: {
        title: "Select Contacts",
        desc: "Select guests one by one from your contact list.",
        selectedCount: "{count} selected",
        selectedText: "{count} of {total} contacts selected",
        searchPlaceholder: "Search name or email…",
        selectAllVisible: "Select all visible",
        noMatch: "No matching contacts.",
        loadingMore: "Loading contacts…"
      },
      label: {
        title: "By Label",
        desc: "Send to one or several labels at the same time.",
        selectedText: "{count} labels · {total} contacts",
        summaryText: "{total} contacts from {count} labels will be sent",
        filterLabel: "Filter Label"
      },
      summary: {
        title: "{count} contacts will receive the email",
        desc: "All contacts with a valid {field} will be sent this invitation."
      },
      validationNoContact: "Please select at least 1 contact recipient.",
      validationNoLabel: "Please select at least 1 label recipient."
    },
    template: {
      title: "Message Template",
      subtitle: "Choose the tone that fits your guests",
      composeTitle: "Compose Message",
      labelSender: "Sender Name",
      labelSubject: "Subject",
      labelSalam: "Opening Greeting",
      labelTitle: "Message Title",
      labelSubtitle: "Message Subtitle",
      labelDescription: "Message Description",
      labelBody: "Message Body",
      labelCta: "Button Text (CTA)",
      btnInsertName: "+ Guest Name",
      btnInsertLink: "+ Invitation Link",
      previewTitle: "Email Preview",
      previewSubtitle: "Example for:",
      previewDummyName: "Made Wirawan",
      previewFrom: "From",
      previewTo: "To",
      previewErrorPrefix: "Failed to load template preview:",
      previewLoading: "Loading preview…"
    },
    finalize: {
      reviewTitle: "Review Before Sending",
      reviewRecipients: "Recipients",
      reviewTemplate: "Template",
      reviewFrom: "From",
      reviewSubject: "Subject",
      unitContact: "contacts",
      recipientListTitle: "Recipient List ({count})",
      statusTitle: "Ready to send to {count} contacts",
      statusDesc: "Emails will be sent one by one with personalization. The process takes about {duration}.",
      statusDuration: "2–3 minutes",
      warningText: "Once sent, the draft cannot be edited or resent. Please make sure the message is correct.",
      btnSendNow: "Send Now",
      btnSending: "Sending...",
      btnTestSend: "Test Send Email",
      needRecipientTooltip: "Select at least 1 recipient contact first",
      toastSending: "Invitation is being sent"
    },
    detail: {
      export: "Export CSV",
      loading: "Loading…",
      statsTotalSent: "Total Sent",
      statsDelivered: "Delivered",
      statsFailed: "Failed",
      updatedPrefix: "Updated",
      templatePrefix: "Template",
      unitContact: "contacts",
      tableTitle: "Status per Contact",
      tableSubtitle: "Detailed delivery history to each guest",
      filters: {
        all: "All",
        sent: "Delivered",
        failed: "Failed"
      },
      columns: {
        contact: "Contact",
        email: "Email",
        status: "Status",
        time: "Time"
      },
      emptyState: "No delivery history yet.",
      loadingHistory: "Loading history…",
      historyStatus: {
        success: "Delivered",
        sent: "Delivered",
        sending: "Sending",
        failed: "Failed",
        pending: "Pending"
      },
      timeEmpty: "—"
    },
    test: {
      title: "Test Send Email",
      description: "Send a sample email to your personal address to make sure the look & content are correct.",
      successTitle: "Test sent successfully",
      successDesc: "Check your inbox at {email}.",
      btnDone: "Done",
      labelEmail: "Your Email",
      placeholderEmail: "name@email.com",
      hint: "We'll send one sample email to this address.",
      btnCancel: "Cancel",
      btnSend: "Send Test Email",
      btnSending: "Sending...",
      invalidEmail: "Invalid email address format."
    },
    guests: {
      title: "Recipient List",
      description: "{count} guests will be sent this invitation via email.",
      searchPlaceholder: "Search name or email…",
      readyBadge: "Ready to send",
      noMatch: "No matching guests.",
      showingCount: "Showing {count} guests",
      btnClose: "Close"
    },
    toast: {
      createDraftError: "Failed to create email share draft. Please try again.",
      saveDraftError: "Failed to save draft. Please try again.",
      sendEmailError: "Failed to send email. Please try again.",
      testEmailSuccess: "Test email sent successfully.",
      testEmailError: "Failed to send test email. Please try again."
    },
    followUp: {
      title: "Automated Follow Up",
      description: "Automatically resend messages to guests after the invitation is shared — for RSVP confirmation and reminding guests who are attending. Set the schedule & template for each type below.",
      status_active: "Active",
      status_inactive: "Inactive",
      save_button: "Save Settings",
      preview_title: "Message Preview",
      preview_meta: "sent D-{days} · example for",
      preview_subject_label: "Subject",
      schedule_label: "Send Schedule",
      days_prefix: "D-",
      days_unit: "days",
      days_before_event: "before the event {date}",
      subject_label: "Email Subject",
      body_label: "Message Body",
      rsvp: {
        label: "RSVP Follow Up",
        desc_prefix: "Sent to guests who",
        desc_bold: "haven't filled out RSVP",
        desc_suffix: ", so they can confirm attendance.",
        default_subject: "Have you confirmed your attendance, {{namaTamu}}?",
        default_body: "Hi {{namaTamu}},\n\nWe haven't received your attendance confirmation for Komang & Ayu's wedding. Your presence means a lot to us.\n\nPlease take a moment to confirm through the digital invitation below."
      },
      reminder: {
        label: "Reminder Follow Up",
        desc_prefix: "Sent to guests who",
        desc_bold: "have RSVP'd and confirmed attendance",
        desc_suffix: ", as a reminder before the event.",
        default_subject: "See you soon, {{namaTamu}}!",
        default_body: "Hi {{namaTamu}},\n\nThank you for confirming your attendance at our wedding. This is a friendly reminder as the big day approaches.\n\nSave the event details & location on the digital invitation below. See you there!"
      },
      insert_vars: {
        namaTamu: "guestName",
        linkUndangan: "invitationLink",
        namaAcara: "eventName"
      }
    },
  },

  Status: {
    belum_aktif: "Not Active",
    paket_pro: "PRO Package",
    paket_basic: "Basic Package",
    expired: "Expired",
    aktif: "Active",
    nonaktif: "Inactive",
    pending: "Pending",
    draft: "Draft"
  },
  Add_Event: {
    pilih_jenis_acara: "Choose Event Type",
    cari_jenis_acara: "Search event type...",
    tidak_ada_hasil_pencarian: "No event type found for",
    kembali: "Back",
    lanjutkan: "Continue"
  },
  Event_Type: {
    custom: "Custom Event",
    pernikahan: "Wedding",
    mepandes: "Mepandes",
    khitanan: "Circumcision",
    birthday: "Birthday",
    kelulusan: "Graduation/Exam Event",
    natal: "Christmas",
    ucapan: "Online Greeting",
    halal: "Halal Bihalal",
    aqiqah: "Aqiqah",
    "3bulanan": "3 Month Celebration",
    melaspas: "Melaspas",
    tahlilan: "Tahlilan",
    baptisan: "Baptism",
    komuni: "First Holy Communion",
    pentahbisan: "Ordination",
    description: {
      custom: "Create a custom invitation according to your needs",
      pernikahan: "Create wedding invitations to share with all guests",
      mepandes: "Mepandes or tooth filing ceremony for Hindus",
      khitanan: "Circumcision ceremony for Muslims",
      birthday: "Birthday party invitation",
      kelulusan: "Graduation, exam, or academic achievement event",
      natal: "Christmas celebration invitation",
      ucapan: "Online greeting for various purposes",
      halal: "Halal bihalal or fellowship event",
      aqiqah: "Suitable for all Islamic children's events",
      "3bulanan": "3-month celebration or tingkeban for pregnant mothers",
      melaspas: "Melaspas ceremony for Hindus",
      tahlilan: "Tahlilan or prayer gathering",
      baptisan: "Ritual to purify oneself and confess faith in Jesus",
      komuni: "First holy communion for Catholics",
      pentahbisan: "Ordination or consecration ceremony"
    }
  },
  CustomForm: {
    title: "Custom Form",
    premium: "Premium",
    no_primary_fields: "No primary form fields available",
    note_hadir: "Questions below will appear when guests select Attend",
    new_fields: "New Fields (Unsaved)",
    unsaved: "Unsaved",
    edit_primary: "Edit Primary Field",
    edit_settings_for: "Change settings for field",
    question_label: "Question Label",
    placeholder_question_label: "Enter question label",
    text_option_attend: "Attend Option Text",
    example_attend: "Example: Yes, I will attend",
    text_option_not_attend: "Not Attend Option Text",
    example_not_attend: "Example: Sorry, I cannot attend",
    hide_doubt_option: "Hide Doubt Option",
    hide_doubt_desc: "Disable the 'still deciding' option for guests.",
    text_option_doubt: "Doubt Option Text",
    example_doubt: "Example: Still Deciding",
    add_question: "Add Question",
    edit_question: "Edit Question",
    add_question_desc: "Set the type and options for custom questions.",
    question_type: "Question Type",
    select_type: "Select Type",
    short_text: "Short Text (Input)",
    multiple_choice: "Multiple Choice (Dropdown)",
    example_question: "Example: Whose side are you from?",
    options_choices: "Choice Options",
    separate_comma: "Separate with commas (Groom, Bride)",
    example_writing: "Example: Groom's Side, Bride's Side",
    is_required: "Is Required?",
    required_desc: "Guests must fill out this field to submit.",
    save_question: "Save Question",
    new_fields_short: "New Fields",
    masukkan: "Enter",
    pilih: "Select",
    kehadiran: "attendance",
    hadir: "Attend",
    tidak_hadir: "Not Attend",
    masih_ragu: "Still Deciding"
  },
  Form_Event: {
    title: "Create New Event",
    subtitle: "Complete your event information below",
    add_event_title: "Add Event",
    edit_event_title: "Edit Event",
    event_address: "Event Address",
    placeholder_event_address: "Full event address",
    event_date: "Event Date",
    select_event_date: "Select event date",
    custom_date: "Custom Date",
    placeholder_custom_date: "Free date format, e.g. 15-16",
    custom_day: "Custom Day",
    placeholder_custom_day: "Example: Saturday",
    start_time: "Event Start Time",
    placeholder_start_time: "Select start time",
    end_time: "Event End Time",
    placeholder_end_time: "Select end time",
    timezone: "Time Zone",
    placeholder_timezone: "Example: WITA",
    custom_time: "Custom Time",
    placeholder_custom_time: "Custom time, e.g. 09.00 - finished",
    until_finished: "Until Finished",
    google_maps_link: "Google Maps Link",
    placeholder_google_maps: "https://goo.gl/maps/...",
    update_event: "Update Event",
    save_event: "Save Event",
    add_event: "Add Event",
    save_order: "Save Order",
    placeholder_event_name: "Example: Wedding Ceremony",
    jenis_acara: "Event Type",
    pilih_jenis_acara: "Choose event type",
    tentang_jenis_acara: "About this event type:",
    no_whatsapp: "WhatsApp Number (Event Owner's WhatsApp)",
    placeholder_whatsapp: "087888999xxx or 6287888999xxx",
    info_whatsapp: "*This number will not be displayed on the invitation",
    tanggal_acara: "Event Date",
    informasi_penting: "Important Information:",
    info_1: "All data can be changed later after the event is created",
    info_2: "Invitation will be active after payment",
    info_3: "By creating an event, you agree to our",
    syarat_ketentuan: "Terms & Conditions",
    kami: "",
    buat_acara: "Create Event",
    membuat_acara: "Creating Event...",
    required: "required",
    fields: {
      nama_acara: "Event Name",
      nama_anak: "Child's Name",
      nama_ayah: "Father's Name",
      nama_ibu: "Mother's Name",
      nama_pria: "Groom's Name",
      nama_wanita: "Bride's Name",
      agama: "Religion",
      nama_yang_ultah: "Birthday Person's Name",
      ulang_tahun_ke: "Birthday Number",
      placeholders: {
        nama_acara: "Enter event name",
        nama_anak: "Enter child's name",
        nama_ayah: "Enter father's name",
        nama_ibu: "Enter mother's name",
        nama_pria: "Enter groom's name",
        nama_wanita: "Enter bride's name",
        pilih_agama: "Select religion",
        nama_yang_ultah: "Enter birthday person's name",
        ulang_tahun_ke: "Enter birthday number"
      }
    },
    agama_options: {
      islam: "Islam",
      kristen: "Christian",
      katolik: "Catholic",
      hindu: "Hindu",
      buddha: "Buddhist",
      khonghucu: "Confucian"
    }
  },
  ManageMenu: {
    titles: {
      progress_setup: "Invitation Setup Progress",
      setting_undangan_dasar: "Basic Invitation Settings",
      progress_setup_undangan: "Invitation Setup Progress",
      edit_langsung_di_undangan: "Edit Invitation Appearance",
      edit_cepat_di_form: "Quick Edit in Form",
      tema_undangan: "Invitation Theme",
      urutan_susunan_komponen: "Component Order Settings",
      musik_undangan: "Invitation Music",
      warna_dan_font_tema: "Theme Colors & Fonts",
      form_kehadiran_dan_ucapan: "RSVP & Wishes Form",
      fitur_auto_scroll: "Auto-Scroll Feature",
      tampilan_whatsapp: "WhatsApp Preview",
      kado_fisik_dan_sticker_gift: "Physical Gift & Sticker Gift",
      kado_fisik_dan_amplop_digital: "Physical Gifts and Digital Envelope",
      atur_form_rsvp_dan_kehadiran: "Attendance RSVP Form",
      sebar_via_whatsapp: "Share via WhatsApp",
      sebar_via_whatsapp_desc: "Send automated invitations via WhatsApp",
      notifikasi_undangan: "Invitation Notification",
      pengaturan: "Settings",
      ubah_nama_tamu_dan_sebar: "Distribute Invitations",
      sebar_otomatis_satu_klik: "Automatic or Manual Invitation Distribution",
      qrcode_checkin_buku_tamu: "Guestbook QRCode Check-in",
      export_desain_cetak: "Export as Print Design",
      custom_undangan_video: "Custom Video Invitation",
      undangan_cetak_fisik: "Create Printed Invitation",
      statistik_laporan_sebar: "Summary Report Spread",
      laporan_ucapan_dan_kehadiran: "Wishes & Attendance Report",
      laporan_buku_tamu: "Guest Book Check-in Report",
      laporan_kado_fisik: "Physical Gift Report",
      laporan_amplop_digital: "Digital Envelope Report",
      laporan_sticker_gift: "Sticker Gift Report",
      pengaturan_google_maps: "Google Maps Settings",
      foto_sampul: "Cover Photo",
      profile_user: "User Profile",
      sebar_undangan_via_email: "Share via Email"
    },
    upgrade: {
      free_title: "Unlock More",
      free_subtitle: "Elevate your invitation",
      pro_title: "Upgrade Premium",
      pro_subtitle: "Unlock VIP features",
      premium_title: "Premium Member",
      premium_subtitle: "All features unlocked"
    },
    descriptions: {
      edit_langsung_di_undangan: "Edit your invitation directly in the invite.",
      edit_cepat_di_form: "Quickly edit your invitation details.",
      tema_undangan: "Choose and customize your invitation theme.",
      urutan_susunan_komponen: "Configure your invitation layout.",
      musik_undangan: "Manage your invitation's music.",
      warna_dan_font_tema: "Customize the theme’s colors and fonts.",
      form_kehadiran_dan_ucapan: "Add an RSVP and message form.",
      fitur_auto_scroll: "Upload and manage your photo gallery.",
      tampilan_whatsapp: "Preview how your invite appears in WhatsApp.",
      kado_fisik_dan_sticker_gift: "Manage gift options and delivery info.",
      kado_fisik_dan_amplop_digital_desc: "Set physical gift delivery address and digital envelope accounts.",
      atur_form_rsvp_dan_kehadiran_desc: "Configure questions for the guest attendance confirmation form.",
      sebar_undangan_via_email: "Manage email invitation distribution. Create drafts, customize messages, and send to your guests.",
      notifikasi_undangan: "Send notifications or reminders for your invite.",
      pengaturan: "View your invitation's stats.",
      ubah_nama_tamu_dan_sebar: "Add guest names and send the invitation.",
      sebar_otomatis_satu_klik: "Send the invite to thousands with one click.",
      qrcode_checkin_buku_tamu: "Digital guestbook using QR codes.",
      export_desain_cetak: "Convert your invite into a print-ready design.",
      custom_undangan_video: "Ask admin to turn your invite into a video.",
      undangan_cetak_fisik: "Print and distribute physical invites via Indoinvite.",
      statistik_laporan_sebar: "Full report on who opened, responded, or sent wishes.",
      laporan_ucapan_dan_kehadiran: "See who sent wishes and confirmed attendance.",
      laporan_buku_tamu: "See who checked in via the digital guestbook.",
      laporan_kado_fisik: "Track who sent physical gifts to the event.",
      laporan_amplop_digital: "View details of income history, withdrawals, and digital envelope balance.",
      laporan_sticker_gift: "Track who sent sticker gifts.",
      pengaturan_google_maps: "Set your event location."
    },
    groups: {
      customize: "Customize Invitation",
      share: "Share Invitation",
      report: "Invitation Report"
    },
    showMore: "Show more",
    showLess: "Show less",
    share_invitation: "Share Invitation",
    lockedBanner: {
      "title": "Invitation Locked",
      "desc": "Trial period has ended. Guests cannot open the invitation & all features are disabled."
    }
  },
  TrialWidget: {
    mobile: {
      lockedTitle: "Invitation Locked",
      lockedSubtitle: "Trial expired · reactivate now",
      activeTitle: "Trial Period Active",
      upgradeButton: "Upgrade",
    },
    desktop: {
      expiredTitle: "Trial Expired",
      expiredSubtitle: "Invitation locked",
      expiredDesc: "Guests cannot access the invitation & all features are disabled. Upgrade to reactivate.",
      upgradeNowButton: "Upgrade Now",
      activeTitle: "Trial Period Active",
      activeSubtitle: "from 3 days free trial",
      selectPackageButton: "Select Upgrade Package",
    },
    units: {
      days: "DAYS",
      hours: "HRS",
      minutes: "MIN",
      seconds: "SEC",
    },
  },
  LockedModal: {
    title: "Invitation Locked",
    description: "The 3-day free trial has ended. Guests cannot access the invitation and all management features are disabled. Upgrade your plan to reactivate.",
    upgradeButton: "Upgrade to Unlock",
  },
  ProgressSetup: {
    title: "Invitation Setup Progress",
    steps_left: "more steps for a",
    perfect_invitation: "perfect invitation",
    desc: "Complete the steps below so your invitation is ready to be shared with guests.",
    completed: "completed",
    step_of_1: "of",
    step_of_2: "steps completed",
    checklist_title: "Setup Checklist",
    badge_required: "Required",
    badge_optional: "Optional",
    btn_skip: "Skip",
    btn_customize: "Customize",
    status_completed: "Completed",
    items: {
      add_guest: { title: "Add guests", desc: "Enter at least one guest to start sharing the invitation link." },
      add_address: { title: "Add gift delivery address", desc: "Display your address so guests can easily send physical gifts to you." },
      add_wa: { title: "Add WA notification for gifts", desc: "Receive WhatsApp notifications every time a gift or digital envelope is received." },
      add_event: { title: "Add event", desc: "Create at least one event so guests know when and where your invitation takes place." },
      custom_rsvp: { title: "Custom RSVP form", desc: "Set up attendance confirmation questions according to your event needs." },
      add_photo: { title: "Add prewedding photos", desc: "Upload a prewedding photo gallery to beautify the invitation page." }
    },
    setup: {
      "progress_setup_title": "Invitation Setup Progress",
      "count_label": "{done} of {total} steps complete",
      title: "Setup Checklist",
      "step_status_info": "The status of each step is automatically detected from your data — no need to mark them manually.",
      "label": {
        "custom_slug": "Custom Slug URL",
        "add_wa_notif": "Add WA Notification for Gift & Digital Envelope Recipients",
        "add_alamat_gift": "Add Gift Recipient Address",
        "add_tamu": "Add Guests",
        "add_acara": "Add Event",
        "add_faq": "Add FAQ",
        "qrcode_checkin": "Enable Digital Guest Book (QR Code Check-in)",
        "add_media": "Add Media to Invitation",
        "custom_gift_registry": "Custom Gift Registry (Select gifts to display on the Invitation)",
        "custom_form_rsvp": "Custom RSVP Form",
        "add_love_story": "Add Love Story"
      },
      "description": {
        "custom_slug": "Set the invitation URL as desired",
        "add_wa_notif": "Enable WhatsApp notifications for gift and digital envelope recipients",
        "add_alamat_gift": "Add an address for gift delivery",
        "add_tamu": "Add an invitation guest list",
        "add_acara": "Add wedding event details",
        "add_faq": "Add frequently asked questions (FAQ) to the invitation",
        "qrcode_checkin": "Enable the digital guest book feature with QR Code check-in",
        "add_media": "Add photos or videos to the invitation",
        "custom_gift_registry": "Select the gifts you want to display in the registry",
        "custom_form_rsvp": "Customize the RSVP form according to your needs",
        "add_love_story": "Tell your love story on the invitation"
      }
    },
    "headline": {
      "loading": "Loading setup progress...",
      "complete": "All steps complete — your invitation is ready to share!",
      "short": "{done} of {total} steps complete",
      "energetic": "Just {remaining} steps left — almost there!",
      "default": "{remaining} steps left to a perfect invitation"
    },
    "subhead": {
      "loading": "Hang tight, we're putting together your step list.",
      "complete": "Great job! You can now start sharing your invitation with all your guests.",
      "short": "Finish the remaining steps below to complete your invitation.",
      "energetic": "Your invitation is almost ready. Wrap up the steps below.",
      "default": "Complete the steps below to get your invitation ready to share with guests."
    },
    "errors": {
      "load_failed": "Failed to load invitation setup progress.",
      "retry": "Try again"
    }
  },
  Modal: {
    form_acara: "Event Form",
    mau_pilih_mana: "Which one do you want to choose?",
    anda_memilih: "You selected:",
    edit_slug_title: "Edit Invitation Link",
    edit_slug_label: "New Invitation Link",
    edit_slug_placeholder: "the-wedding-of-pande-desak-8",
    edit_slug_error_empty: "Slug (link) cannot be empty.",
    edit_slug_error_save: "Failed to save invitation link.",
    edit_slug_button_cancel: "Cancel",
    edit_slug_button_saving: "Saving...",
    edit_slug_button_save: "Save Changes"
  },
  Search: {
    placeholder: "Search...",
    tidak_ditemukan: "Not found",
    hasil_untuk: "Search results for",
    menampilkan: "Showing",
    dari: "of",
    total: "total",
    placeholder_acara: "Search event name...",
    acara_tidak_ditemukan: "Event not found",
    tidak_ada_acara_cocok: "No events match the keyword",
    kolaborasi_tidak_ditemukan: "Collaboration not found",
    tidak_ada_kolaborasi_cocok: "No collaboration invitations match the keyword",
  },
  Pagination: {
    sebelumnya: "Prev",
    selanjutnya: "Next",
    kembali: "Back",
    lanjutkan: "Next",
    halaman: "Page",
    dari_total: "of",
    ke: "to",
    menampilkan: "Showing"
  },
  Breadcrumb: {
    beranda: "Home",
    dashboard: "Dashboard",
    acara: "Events",
    buat_acara: "Create Event",
    edit_acara: "Edit Event"
  },
  Error: {
    gagal_import: "Failed to import data",
    email_wajib_diisi: "Email is required.",
    judul_acara_wajib_diisi: "Event title is required.",
    whatsapp_wajib_diisi: "WhatsApp number is required.",
    format_email_tidak_valid: "Invalid email format.",
    format_whatsapp_tidak_valid: "WhatsApp number must be numeric (10-15 digits).",
    terjadi_kesalahan: "An error occurred",
    coba_lagi: "Try again",
    halaman_tidak_ditemukan: "Page not found",
    kembali_ke_beranda: "Back to home",
    koneksi_terputus: "Connection lost",
    periksa_koneksi: "Check your internet connection",
    error_404: "404 - Page Not Found",
    error_500: "500 - Server Error",
    error_generic: "An error occurred. Please try again later.",
    "belum_publish": "Not Published",
    "error_publish_undangan_desc": "This Invitation Link Cannot Be Opened",
    "error_publish_undangan_lead": "Sorry! The invitation link you opened has not been published yet. Please contact the event owner for more information.",
    "error_publish_undangan_desc_2": "Contact the invitation owner to make sure the invitation has been published before opening it.",
    "error_private_undangan_badge": "Private Invitation",
    "error_private_undangan": "Sorry! The invitation link you opened is a Private Link",
    "error_private_undangan_desc": "Only registered guests can open this invitation. Please contact the event owner for further information.",
    "error_private_undangan_hint": 'Contact the invitation owner to get access, or make sure your name is already registered as a guest.',
    gagal_menduplikat: "Oops, failed to duplicate the invitation. Please try again.",
    fitur_maintenance: "This feature is currently under maintenance.",
    hanya_pemilik: "Only the Event Owner can access this feature.",
    pilih_user_dulu: "Please select a user from the search list first.",
    akun_sendiri: "You cannot add your own account.",
    maksimal_hak_akses: "Sorry, you can only grant access to a maximum of 10 users.",
    sudah_ada_akses: "This user already has access.",
    gagal_tambah_akses: "Oops, failed to grant access. Please try again later.",
    gagal_hapus_akses: "Oops, failed to remove access. Let's try again!",
    gagal_hapus_field: "Failed to delete field",
    label_wajib: "Field label is required",
    gagal_primary: "Failed to update primary field",
    field_name_wajib: "Field name is required",
    opsi_wajib: "At least 1 option is required",
    gagal_simpan_field: "Failed to save field",
    gagal_ubah_visibility: "Failed to change field visibility",
    tidak_ada_field_baru: "No new fields to save",
    gagal_simpan_custom_form: "Failed to save custom form",
    gagal_simpan_pilihan: "Failed to save selection.",
    nama_penerima_wajib: "Recipient's Full Name is required!",
    nomor_hp_wajib: "Phone Number is required!",
    nomor_hp_kurang_valid: "Phone Number is invalid. Please make sure the number is correct!",
    provinsi_wajib: "Province is required!",
    kabupaten_wajib: "Regency/City is required!",
    kecamatan_wajib: "District is required!",
    desa_wajib: "Village is required!",
    kodepos_wajib: "Postal Code is required!",
    alamat_lengkap_wajib: "Full Address is required!",
    gagal_simpan_pengaturan: "Failed to save settings.",
    gagal_memuat_tamu: "Failed to load guest list.",
    nama_tamu_wajib: "Oops, the guest's name has not been filled out.",
    email_tidak_valid: "Hmm, the email format doesn't seem quite right. Check again!",
    wa_kependekan: "Oops, the WA number is too short. Please ensure it's valid!",
    gagal_update_data: "Failed to update data. Check the Console Log (Inspect Element).",
    nama_tamu_wajib_singkat: "Guest name cannot be empty!",
    gagal_simpan_perubahan: "Failed to save changes",
    gagal_proses_data: "Failed to process data",
    gagal_export: "Failed to export guest data.",
    wa_minimal_9: "Format Failed: Whatsapp must be at least 9 digits!",
    email_tidak_valid_singkat: "Format Failed: Invalid email!",
    max_group_negatif: "Failed: Max group cannot be negative!",
    isi_minimal_satu: "Fill in at least one name",
    pilih_file: "Select a file",
    pilih_1_data: "Please select only 1 item to edit.",
    tamu_tidak_ditemukan: "Guest not found!",
    pilih_template_dulu: "Please select a template first.",
    gagal_simpan_template: "Failed to save template.",
    gagal_simpan_template_custom: "Failed to save custom template.",
    gagal_mulai_sebar: "Failed to start sharing process. Please try again.",
    selesaikan_penerima_dulu: "Complete the Recipient step first.",
    selesaikan_sebelumnya_dulu: "Complete the previous step first.",
    data_undangan_belum_siap: "Invitation data is not ready. Please refresh the page.",
    data_id_belum_dimuat: "ID data has not loaded. Please wait a moment or refresh the page.",
    kesalahan_data_id: "An ID data error occurred. Please try again.",
    data_encrypted_belum_siap: "Encrypted ID data is not ready. Wait a moment or refresh the page.",
    gagal_hapus_data: "Failed to delete data.",
    gagal_perbarui_rsvp: "Failed to update RSVP.",
    balasan_wajib: "Reply cannot be empty",
    gagal_kirim_balasan: "Failed to send reply.",
    tamu_manual_no_detail: "Manual guest data has no additional details.",
    gagal_muat_data_refresh: "Failed to load the latest data. Please refresh.",
    gagal_penarikan: "Failed to process withdrawal",
    undangan_tidak_ditemukan: "Invitation not found.",
    gagal_hapus_undangan: "Failed to delete invitation",
    tidak_bisa_hapus_undangan_aktif: "Active invitations or invitations with a purchased package cannot be deleted.",
    gagal_mengarsipkan: "Failed to archive invitation",
    gagal_memulihkan: "Failed to restore invitation",
    data_acara_tidak_ditemukan: "Event data not found. Please restart.",
    gagal_memuat_tema: "Failed to load theme list.",
    payload_tidak_valid: "Invalid data payload.",
    gagal_memuat_paket: "Failed to load package list.",
    pilih_paket_dulu: "Please select a package first.",
    gagal_buat_undangan: "Failed to create invitation. Please try again.",
    gagal_logout: "Failed to connect to the server during logout. Please try again.",
  },
  Guest: {
    batal_pilih_semua: "Deselect all",
    urutkan_berdasarkan: "SORT BY",
    nama_a_z: "Name A–Z",
    nama_z_a: "Name Z–A",
    terakhir_ditambahkan: "Recently Added",
    kirim_undangan: "Send Invitation",
    detail: "Detail",
    belum_ada_tamu: "Guests not found",
    sebar_via_wa: "Share via WhatsApp",
    sebar_via_email: "Share via Email",
    tamu: "Guest",
    sebar_otomatis: "Auto Share",
    mengimport_data: "Importing data...",
    import_file: "Import File",
    disini: "here",
    klik_untuk_mengisi: "Click to fill",
    klik_untuk_mengedit_wa: "Click to edit Whatsapp",
    semua_acara: "All Events",
    pilih_semua: "Select All",
    menyiapkan_export: "Preparing CSV export file...",
    nama: "Name",
    whatsapp: "Whatsapp",
    email: "Email",
    acara: "Event",
    label: "Label",
    tanpa_label: "No Label",
    max_group: "Max Group",
    action: "Action",
    tambah_tamu_undangan: "Add Invited Guest",
    kelola_tamu: "Manage Guests",
    daftar_tamu: "Guest List",
    deskripsi_daftar_tamu: "Add a list of guests to whom you will send the invitation link",
    tambah_tamu: "Add Guest",
    sebar_undangan: "Share Invitation",
    semua_label: "All Labels",
    cari_nama_wa: "Search name or WA...",
    export_csv: "Export Data (CSV)",
    hint_mobile: "Click a row to view details, or click a guest's name to share invitation",
    nama_tamu: "Guest Name",
    pilih_label_opsional: "Select Label (Optional)",
    max_group_desc: "Max Group - Number of extra guests they can bring",
    edit_tamu: "Edit Guest",
    tambah_satuan: "single",
    tambah_cepat: "quick",
    import_excel: "Import Excel",
    contoh_nama: "Example: John Doe",
    err_nama_kosong: "Please write the guest's name first, don't leave it blank.",
    contoh_email: "name@email.com (Optional)",
    err_email_typo: "There seems to be a typo in the email format.",
    err_wa_9_digit: "WA number must be at least 9 digits so the invitation can be sent.",
    acara_default: "Event (Default: All Events)",
    kelola_label: "Manage Labels",
    nama_tamu_enter: "Guest Name (Separate with Enter)",
    ketik_nama: "Type name...",
    download_format: "Download format here",
    click_to_upload: "Click to upload",
    hapus_tamu: "Delete Guest",
    dipilih: "Selected",
  },
  GuestBook: {
    mode_matikan: "Turn Off",
    mode_manual: "Staff Check-in",
    mode_manual_desc: "Show your QR code to the event staff for check-in.",
    mode_scan: "Self Check-in",
    mode_scan_desc: "Scan the venue QR code to check yourself in.",
    qr_code_manual: "MANUAL QR CODE",
    cara_menggunakan: "How to use:",
    step_manual_1: 'Click the "Committee Barcode Scan App" button below to open the scanner app for the usher committee.',
    step_manual_2: "Once opened, allow browser camera access for the Committee Barcode Scan App.",
    step_manual_3: "When a guest arrives, ask them to click the QRCode icon on their invitation menu, and the QRCode will appear.",
    step_manual_4: "Scan that QRCode using the Committee Barcode Scan App.",
    tonton_tutorial: "Watch Tutorial",
    qr_code_peduli_lindungi: "SELF-SCAN QR CODE",
    desc_peduli_lindungi: "Self-Scan QRCode works similarly to self-check-in applications. Here is how to use it:",
    step_scan_1: "The committee needs to print the QR-Code below and place it on the reception desk.",
    step_scan_2: "When a guest arrives, ask them to click the QRCode icon on their invitation link, then allow camera access.",
    step_scan_3: "Then point their camera to the QRCode below.",
    info_umum_1: "This feature replaces the Manual Guest Book. Attending guests will be asked to scan a QRCode via their digital invitation link.",
    info_umum_2: "Guests who successfully scan will automatically be recorded as having attended the event.",
    deskripsi_halaman: "This page manages the use of QRCode guest book check-ins",
    pilih_mode_qrcode: "Choose QRCode Check-in Mode",
    buka_aplikasi_scan_1: "Click the button below to open the Committee Barcode Scanner App.",
    buka_aplikasi_scan_2: "Then grant camera access to the browser.",
    aplikasi_scan_panitia: "Committee QRCode Scanner App",
    layar_sapa: "Greeting Screen",
    scan_checkin_title: "GUEST BOOK CHECK-IN SCAN",
    scan_instruction_print_1: "Open the invitation link, click the QRCode icon, grant camera access,",
    scan_instruction_print_2: "then point the camera at the QRCode",
    memuat_qr: "Loading QR...",
    desc_print_1: "Print this QRCode and place it at the event entrance.",
    desc_print_2: "Invited guests open their invitation link, click the QRCode icon, and grant camera access.",
    desc_print_3: "Point the camera at the QRCode to Check-in.",
    menyiapkan_gambar: "Preparing Image...",
    download_qr: "Download Check-in QRCode"
  },
  Success: {
    import_berhasil: "Guest data imported successfully!",
    berhasil_disimpan: "Data successfully saved",
    berhasil_dihapus: "Data successfully deleted",
    berhasil_diupdate: "Data successfully updated",
    acara_berhasil_dibuat: "Event successfully created",
    undangan_berhasil_dikirim: "Invitation successfully sent",
    berhasil_diduplikat: "Hooray! Invitation duplicated successfully.",
    berhasil_diarsipkan: "Invitation archived successfully",
    berhasil_dipulihkan: "Invitation restored successfully",
    id_disalin: "ID copied",
    berhasil_tambah_akses: "Hooray! User access granted successfully.",
    berhasil_hapus_akses: "Great! User access removed successfully.",
    field_dihapus: "Field successfully deleted:",
    primary_diupdate: "Primary field updated successfully",
    field_diupdate: "Field updated successfully",
    field_diubah_belum_simpan: "Field modified (unsaved)",
    field_ditambah_belum_simpan: "Field added (unsaved)",
    field_diaktifkan: "successfully enabled",
    field_dinonaktifkan: "successfully disabled",
    custom_form_disimpan: "Custom form saved successfully",
    kado_diperbarui: "Gift list updated successfully!",
    pengaturan_disimpan: "Settings saved successfully!",
    data_diperbarui: "Data updated successfully!",
    tamu_diperbarui: "Guest data updated successfully!",
    data_dihapus: "Data successfully deleted",
    berhasil_export: "Successfully downloaded CSV guest data!",
    tamu_ditambahkan: "Guest added",
    pesan_link_disalin: "Message & Link copied!",
    pesan_disalin: "Message copied",
    template_dipilih: "Template '{name}' selected.",
    template_custom_disimpan: "Custom template saved.",
    link_disalin: "Link copied successfully!",
    pembayaran_berhasil: "Payment successful!",
    limit_diperbarui: "Your limit has been updated.",
    proses_sebar_dimulai: "Auto share process started!",
    undangan_dikirim: "invitations are being sent.",
    template_disimpan: "Template {name} saved.",
    buka_aplikasi_scan_1: "Click the button below to open the Committee Barcode Scanner App.",
    buka_aplikasi_scan_2: "Then grant camera access to the browser.",
    aplikasi_scan_panitia: "Committee QRCode Scanner App",
    layar_sapa: "Greeting Screen",
    rsvp_diperbarui: "RSVP data updated successfully!",
    balasan_terkirim: "Reply sent successfully!",
    kehadiran_diupdate: "Attendance updated successfully!",
    penarikan_berhasil: "Withdrawal request sent successfully",
    teks_sebar_disalin: "Share text successfully copied!",
    dipilih: "selected.",
    template_custom_tersimpan: "Custom template saved.",
    undangan_dihapus: "Invitation successfully deleted",
    undangan_berhasil_dibuat: "Invitation created successfully!",
    berhasil_logout: "Successfully logged out!",
  },
  Confirmation: {
    yakin_hapus: "Are you sure you want to delete?",
    tindakan_tidak_bisa_dibatalkan: "This action cannot be undone",
    ya_hapus: "Yes, Delete",
    yakin_keluar: "Are you sure you want to leave?",
    data_belum_disimpan: "Unsaved data will be lost",
    ya_keluar: "Yes, Leave",
    tetap_disini: "Stay here",
    yakin_hapus_field: "Are you sure you want to delete field",
    ya_hapus_data: "Yes, Delete Data",
    hapus_banyak_data: "Are you sure you want to delete the {count} selected data? This action cannot be undone.",
    berhasil_logout: "Successfully logged out!",
  },
  Pricing: {
    paket_saat_ini: "Current Package",
    upgrade_sekarang: "Upgrade Now",
    paket_harga_elynk: "Elynk Pricing Packages",
    data_belum_tersedia: "Package data is not available yet.",
    sudah_termasuk: "Included in the Package"
  },
  Share: {
    detail_tamu: "Detail Tamu",
    title: "Send & Share Invitation",
    description: "Distribute invitations to guests, either manually one-by-one or broadcast automatically with one click",
    sebar_otomatis: "Auto Broadcast",
    sebar_manual: "Manual Share",
    pernikahan_kami: "Our Wedding",
    custom: "Custom",
    sebar_link: "Share Link",
    tamu_undangan_contoh: "Guest+Name",
    ubah_nama_tamu_hint: "To change the guest name on the invitation, edit the link after",
    sebar_dengan_template: "Share With Template",
    pilih_template: "Choose Template",
    sedang_menggunakan_template: "Currently using template",
    cari_tamu: "Search guest...",
    link: "Link",
    sebar: "Share",
    sebar_lain: "Share Others",
    belum_dipilih: "Not selected",
    status_dibaca: "Read",
    status_terkirim: "Delivered",
    status_mengirim: "Sending",
    status_gagal: "Failed",
    status_menunggu: "Pending",
    waktu_diterima: "Time Received",
    batch_id: "Batch ID",
    langkah_sebar: "Sharing steps!",
    sisa_limit: "Remaining Limit:",
    penerima_undangan: "Invitation Recipients",
    total_penerima_terpilih: "Total {count} Recipients Selected",
    pilih_siapa_menerima: "Choose who will receive the invitation",
    template_pesan: "Message Template",
    menggunakan: "Using:",
    pilih_pesan_dikirim: "Select the message to send",
    limit: "Limit",
    kurang_limit: "Short {count} Limit! Click to add.",
    limit_tersedia: "Available Limit: {limit} (Need: {need})",
    konfirmasi_kirim: "Confirm & Send",
    siap_disebarkan: "Ready to share",
    mulai_sebar: "Start Sharing Invitation",
    note_limit: "Note: 1 message recipient requires 1 Limit",
    bot_name: "Elynk",
    official_account: "Official Account",
    hari_ini: "Today",
    cover_undangan: "Invitation_Cover.jpg",
    belum_ada_template: "No template selected.",
    silakan_pilih_template: "Please select a template from the left menu.",
    history_sebar: "Share History",
    semua_status: "All Status",
    belum_ada_riwayat: "No delivery history yet.",
    kelola_penerima: "Manage Invitation Recipients",
    semua_tamu_undangan: "All Invited Guests",
    desc_semua_tamu: "All invited guests who have WA numbers in Manage Guests",
    pilih_dari_label: "Select From Label",
    terpilih_teks: "selected",
    terpilih_btn: "Selected",
    desc_pilih_label: "Select invitation recipients from a specific label",
    tidak_ada_label: "No labels available.",
    pilih_dari_tamu: "Select From Invited Guests",
    desc_pilih_manual: "Select from the list of invited guests manually",
    tidak_ada_tamu: "No guests found",
    simpan_penerima_undangan: "Save Invitation Recipients",
    simpan_penerima: "Save Recipients",
    cari_nama_wa: "Search name or WA...",
    pilih_template_sebar_otomatis: "Choose Auto Share Template",
    pilih_template_sebar_manual: "Choose Manual Share Template",
    tulis_pesan_undangan: "Write invitation message...",
    sisipkan: "Insert:",
    nama_tamu_btn: "Guest Name",
    link_undangan_btn: "Invitation Link",
    pilih_template_placeholder: "Choose a template...",
    simpan_template: "Save Template",
    edit_template_ini: "Edit This Template",
    gunakan_template_ini: "Use This Template",
    tambah_limit_sebar: "Add Share Limit",
    desc_limit_sebar: "Limits are used to send automated messages to invited guests.",
    pembelian_limit: "Limit Purchase",
    total_pembayaran: "Total Payment",
    lanjut_pembayaran: "Proceed to Payment",
    konfirmasi_sebar: "Confirm Sharing",
    mulai_sebar_undangan: "Start Sharing Invitation?",
    anda_akan_mengirim_ke: "You are about to send invitations to",
    penerima: "recipients",
    terpilih_pastikan_limit: "selected. Please make sure you have enough limit quota.",
    memproses: "Processing...",
    kirim_sekarang: "Send Now",
    desc_detail_tamu: "View RSVP history, wishes, physical gifts, and digital envelopes.",
    ringkasan: "Overview",
    rsvp: "RSVP",
    ucapan: "Wishes",
    hadiah: "Gifts",
    status_undangan: "Invitation Status",
    total_hadir: "Total Attending",
    belum_rsvp: "Not RSVP'd Yet",
    detail_kehadiran: "Attendance Details",
    pertanyaan_tambahan: "Additional Questions",
    menunggu_balasan: "Waiting for Reply",
    belum_ada_ucapan_dari_tamu: "No wishes from this guest yet.",
    total_hadiah: "Total Gifts (Estimated Funds)",
    kado_fisik: "Physical Gifts",
    amplop_digital: "Digital Envelopes",
    total_kado_fisik: "Total Physical Gifts",
    total_amplop_digital: "Total Digital Envelopes",
    transfer: "Transfer",
    sebar_ulang: "Reshare",
    memuat_detail_tamu: "Loading guest details...",
    data_tamu_tidak_ditemukan: "Guest data not found.",
    tamu_umum: "General Guest",
    rsvp_checkin: "RSVP & Check-in",
    kado_amplop: "Gift & Envelope",
    nama_terdaftar: "Registered Name",
    semua_acara: "All Events",
    max_kuota_hadir: "Max Attendance Quota",
    tidak_dibatasi: "Unlimited",
    orang: "Person(s)",
    konfirmasi: "Confirmation",
    hadir: "Attend",
    balasan_anda: "Your Reply",
    belum_ada_ucapan: "No wishes yet.",
    data_checkin: "Check-in Data (Guest Book)",
    sudah_checkin: "Checked-in",
    belum_checkin: "Not Checked-in",
    jumlah_hadir_aktual: "Actual Attendees",
    waktu_hadir: "Check-in Time",
    tidak_ada_kado_fisik: "No physical gift data.",
    kirim_undangan: "Send Invitation",
    default_umum: "General Default",
    muslim_1: "Muslim 1",
    english_1: "English 1",
    undangan_title: "Invitation",
    link_sebar: "Share Link",
    tersalin: "Copied",
    copy: "Copy",
    sesuaikan_template: "Customize Template",
    teks_tersalin: "Text Copied!",
    copy_teks_sebar: "Copy Share Text",
    membuka_whatsapp: "Opening WhatsApp...",
    kirim_ke_whatsapp: "Send to WhatsApp",
    membuka_share: "Opening Share...",
    sebar_lainnya: "Share Other",
    sebar_masal_otomatis: "Auto Mass Share",
    sebar_undangan_manual: "Manual Share Invitation",
    lainnya: "Others",
    nama_acara_btn: "Event Name",
    nomor_pengirim: "Organizer's WhatsApp Number",
  },
  Time: {
    hari_ini: "Today",
    kemarin: "Yesterday",
    minggu_lalu: "Last week",
    bulan_lalu: "Last month",
    tahun_lalu: "Last year",
    detik_lalu: "seconds ago",
    menit_lalu: "minutes ago",
    jam_lalu: "hours ago",
    hari_lalu: "days ago"
  },
  Component: {
    "c-gift-registry": "Gift Registry",
    "c-open-invitation-button": "Open Invitation Button",
    "c-guest-name": "Guest Name",
    "c-ucapan-footer": "Text (Footer)",
    "c-image-list": "List of Images",
    "c-sampul": "Image Cover",
    "c-profile": "List of Profiles",
    "c-link": "List of Links",
    "c-doa": "Text (Blessing)",
    "c-embed-map": "Map Embed",
    "c-ucapan-penutup": "Text (Closing Message)",
    "c-acara": "Event Details",
    "c-data-wanita": "Bride Profile",
    "c-data-pria": "Groom Profile",
    "c-ucapan-pembuka": "Text (Opening Message)",
    "c-galery": "Photo Gallery",
    "c-kehadiran": "RSVP (Attendance)",
    "c-pengumuman": "Text (Announcement)",
    "c-hadiah": "Gift (Digital Envelope)",
    "c-hitung-mundur": "Event Countdown",
    "c-susunan-acara": "Event Rundown",
    "c-story": "Love Story",
    "c-nama-acara": "Heading (Title)",
    "c-dresscode": "Dress Code",
    "c-faq": "FAQ",
    "c-video": "Video",
    "c-list-ucapan": "List of Wishes",
    "c-spacer": "Spacer"
  },
  EditComponent: {
    edit_gallery: "Photo Gallery",
    edit_sampul: "Image Cover",
    edit_groom: "Groom Profile",
    edit_dresscode: "Dress Code",
    edit_faq: "FAQ",
    edit_video: "Video",
    edit_bride: "Bride Profile",
    edit_image_list: "List of Images",
    edit_susunan_acara: "Event Rundown",
    edit_profile: "List of Profiles",
    edit_link: "List of Links",
    edit_love_story: "Love Story",
    edit_gift_registry: "Gift Registry",
    edit_gift: "Gift (Digital Envelope)",
    edit_countdown: "Event Countdown",
    edit_attendance: "RSVP (Attendance)",
    edit_list_ucapan: "List of Wishes",
    reset_data_tooltip: "Reset Data",
    reset_confirm_title: "Confirm Data Reset",
    reset_confirm_desc: "Are you sure you want to reset the {name} data? This action cannot be undone.",
    reset_confirm_button: "Reset Data",
    reset_loading_button: "Resetting...",
  },
  Settings: {
    deskripsi_header: "Event settings to manage event name, cover, notifications, and other settings",
    preference_title: "Preference",
    preference_deskripsi_header: "Manage application preferences such as display language",
    language_setting: "Language Setting",
    language_setting_desc: "Choose the display language you want to use.",
    inspirasi_menu: "Inspiration",
    inspirasi_title: "Inspiration",
    inspirasi_desc: "Browse digital invitations made by other users for inspiration.",
    inspirasi_muat_lebih_banyak: "Load more",
    inspirasi_kosong: "No inspiration in this category yet.",
    inspirasi_kategori_semua: "All",
    inspirasi_kategori_pernikahan: "Wedding",
    inspirasi_kategori_khitanan: "Circumcision",
    inspirasi_kategori_grand_opening: "Grand Opening",
    inspirasi_kategori_aqiqah: "Aqiqah",
    inspirasi_kategori_ulang_tahun: "Birthday",
    tutorial_menu: "Tutorial",
    tutorial_title: "Tutorial",
    tutorial_desc: "Step-by-step guides to help you get the most out of your invitation.",
    tutorial_muat_lebih_banyak: "Load more",
    tutorial_kosong: "No tutorials in this category yet.",
    tutorial_kategori_semua: "All",
    tutorial_kembali: "Back to tutorial list",
    tutorial_tidak_ditemukan: "Tutorial not found.",
    tutorial_video_panduan: "Video Guide",
    tutorial_langkah_langkah: "Steps",
    tutorial_tips: "Tips",
    detail_acara: "Event Details",
    notifikasi: "Notifications",
    hak_akses: "Permissions",
    pengaturan_undangan: "Invitation Settings",
    placeholder_judul_acara: "Example: The Wedding of Romeo & Juliet",
    deskripsi_acara: "Event Description",
    placeholder_deskripsi_acara: "Write a brief description of the event...",
    no_image: "No Image",
    pilih_foto_sampul: "Choose Cover Photo",
    pilih_gambar_media: "Choose Image from Media",
    deskripsi_notifikasi: "Manage attendance notifications and confirmation messages.",
    cari_negara: "Search country or code...",
    negara_tidak_ditemukan: "Country not found",
    chat_id_telegram: "Telegram Chat ID",
    placeholder_chat_id: "Enter Chat ID",
    notif_kado: "Physical Gift & Digital Envelope Notifications",
    notif_rsvp: "RSVP Attendance Notifications",
    notif_marketing: "Elynk.co Marketing Notifications",
    deskripsi_hak_akses: "Manage who can administer your event",
    cari_pengguna: "Search User by Email/Name",
    placeholder_cari_pengguna: "Type email or name...",
    akun_anda: "Your Account",
    memiliki_hak_akses: "Users with access",
    hapus_akses: "Remove Access",
    deskripsi_pengaturan: "Manage invitation status, type, and language.",
    status_publish: "Publish Status",
    publish_publik: "Publish (Publicly accessible)",
    draft_admin: "Draft (Admin only)",
    tipe_undangan: "Invitation Type",
    tamu_publik: "Public Guests",
    tamu_private: "Private Guests (Only invited ones)",
    bahasa_undangan: "Invitation Language",
    indonesia: "Indonesia",
    english: "English",
    default_max_group: "Default Max Group",
    contoh_10: "Example: 10",
    deskripsi_max_group: "Maximum number of guests that can attend in a single invitation group."
  },
  SettingsFont: {
    font_header: "Header Font",
    font_sub_header: "Sub Header Font",
    font_description: "Description Font",
    pilih_font: "Choose Font",
    atur_style_font: "Set Font Style",
    "reset_font_title": "Reset fonts to default?",
    "reset_font_description": "Header, sub header, and description fonts will be restored to the theme's default settings. This action can't be undone."
  },
  "SettingsColor": {
    "reset_warna": "Reset colors",
    "reset_warna_title": "Reset colors to default?",
    "reset_warna_description": "All colors, including primary, secondary, heading text, body text, and other colors, will be restored to the theme's default settings. This action can't be undone.",
    "mereset": "Resetting..."
  },
  Gift: {
    setting_tab: "Settings",
    pilih_kado_fisik_tab: "Choose Physical Gift",
    kado_fisik: "Physical Gift",
    amplop_digital: "Digital Envelope",
    pilih_kado: "Choose Gift",
    sesuaikan_kado: "Customize Gift",
    pilih_semua_kado: "Select All Gifts",
    pilih_beberapa_kado: "Select Multiple Gifts",
    cari_kado_placeholder: "Search gifts...",
    tidak_ada_master_kado: "No master gift data available.",
    list_kado_tampil: "Gift List Displayed on Invitation",
    cari_kado_terpilih: "Search selected gifts...",
    refresh_data: "Refresh Data",
    belum_ada_kado_dipilih: "No gifts selected yet.",
    gambar: "Image",
    kado: "Gift",
    harga: "Price",
    kado_pernikahan_default: "Wedding gift",
    fitur_kado_fisik: "Physical Gift Feature",
    info_kado_fisik_1: "Physical Gift allows guests to send gifts directly from the Digital Invitation. After payment is confirmed, the event owner will receive a",
    notifikasi: "notification",
    info_kado_fisik_2: ", and our team will prepare and send the gift according to the owner's confirmation.",
    aktifkan_kado_fisik: "Enable Physical Gift Feature",
    detail_penerima_kado: "Gift Recipient Details",
    nama_lengkap: "Full Name",
    placeholder_nama_lengkap: "Recipient's Full Name",
    nomor_hp: "Phone Number",
    alamat_pengiriman: "Shipping Address",
    pilih_provinsi: "Select Province",
    pilih_kabupaten: "Select Regency/City",
    pilih_kecamatan: "Select District",
    pilih_desa: "Select Village",
    kode_pos: "Postal Code",
    alamat_lengkap: "Full Address",
    placeholder_alamat: "Full Address (Street, House No, RT/RW, Landmarks)",
    fitur_amplop_digital: "Digital Envelope Feature",
    info_amplop_digital_1: "Digital Envelope allows guests to send money cashless. Payments are automatically verified, and the event owner will receive a",
    info_amplop_digital_2: "in realtime via whatsapp and email (Make sure you have set up Notifications in the ",
    setting_notifikasi_link: "Notification Settings",
    info_amplop_digital_3: " menu). The event owner can withdraw funds on the report page.",
    aktifkan_amplop_digital: "Enable Digital Envelope Feature",
    pesan_fitur_kado_dinonaktifkan: "The Physical Gift feature is currently disabled. Guests will not be able to view or send physical gifts on the invitation page.",
    pesan_fitur_amplop_dinonaktifkan: "The Digital Envelope feature is currently disabled. Guests will not be able to make cashless payments on the invitation page."
  },
  Statistics: {
    title: "Invitation Sharing Statistics",
    loading_stats: "Loading statistics data...",
    desc: "Complete report to view invitation sharing data",
    total_digital_envelope: "Total Digital Envelope",
    detail_digital_envelope: "Digital Envelope Detail",
    total_physical_gift: "Total Physical Gift",
    gift_unit: "Gifts",
    detail_gift: "Gift Detail",
    view_invitation: "Invitation Views",
    open_invitation: "Invitation Opens",
    wishes: "Wishes",
    guest_confirmation: "Guest Confirmation",
    copy_account: "Account Copied",
    click_maps: "Maps Clicked",
    click_gallery: "Gallery Clicked",
    guest_wishes: "Guest Wishes",
    detail_wishes: "Wishes Detail",
    name: "Name",
    no_name: "No Name",
    no_wishes_data: "No wishes data yet",
    detail_rsvp: "RSVP Detail",
    confirmation: "Confirmation",
    attend: "Attend",
    person_unit: "Person",
    no_confirmation_data: "No confirmation data yet"
  },
  Report: {
    title: "Attendance & Wishes Report",
    info_detail: "Detailed information for this data",
    ucapan_dari: "Wish from",
    detail_ucapan: "Wish Details",
    sembunyikan_ucapan: "Hide Wish",
    tampilkan_ucapan: "Show Wish",
    pilih_acara: "Select Event...",
    edit_data_rsvp: "Edit RSVP Data",
    konfirmasi_kehadiran: "Attendance Confirmation",
    pilih_kehadiran: "Select Attendance",
    jumlah_hadir: "Number of Guests",
    memuat_pertanyaan_tambahan: "Loading additional questions...",
    custom_form_lainnya: "Other Custom Forms",
    rsvp_tab: "Attendance",
    wishes_tab: "Wishes",
    export_csv: "Export Report (CSV)",
    total_konfirmasi: "Total Confirmations",
    status_hadir: "Attending",
    status_tidak_hadir: "Not Attending",
    status_ragu: "Still Deciding",
    semua_acara: "All Events",
    semua_status: "All Statuses",
    search_guest_placeholder: "Search guest name...",
    guest_name: "Guest Name",
    nama: "Name",
    attendance: "Attendance",
    konfirmasi: "Confirmation",
    amount: "Amount",
    hadir: "Attending",
    time: "Time",
    actions: "Actions",
    total_ucapan: "Total Wishes",
    replied: "Replied",
    not_replied: "Not Replied",
    all_status: "All Statuses",
    search_wishes_placeholder: "Search name or wish...",
    cari_ucapan: "Search wish...",
    wish: "Wish",
    ucapan: "Wishes",
    status: "Status",
    replied_by_owner: "Event Owner's Reply",
    delete_confirmation_title: "Confirm Deletion",
    delete_confirmation_desc: "Are you sure you want to permanently delete this data? This action cannot be undone.",
    hapus_data_desc: "You are about to delete {count} selected items.",
    konfirmasi_hapus_pesan_tamu: "Are you sure you want to delete {name}'s message?",
    konfirmasi_sembunyikan_ucapan: "Are you sure you want to hide this wish?",
    konfirmasi_tampilkan_ucapan: "Are you sure you want to show this wish?",
    confirm_delete: "Yes, Delete",
    menyiapkan_export: "Preparing export file...",
    custom_field: "Custom Field",
    tanpa_nama: "No Name",
    klik_detail: "Click to view details",
    balas: "Reply",
    desc: "Report to view guests who are attending and not attending the event",
    tamu_konfirmasi: "Confirmed Guests",
    belum_konfirmasi: "Unconfirmed Guests",
    jumlah_orang_hadir: "Number of Attendees",
    cari_tamu: "Search guest...",
    belum_ada_rsvp: "No RSVP data yet.",
    belum_ada_ucapan: "No Wishes data yet.",
    orang: "Guests",
    detail_tamu: "Guest Details",
    memuat_detail_tamu: "Loading guest details...",
    data_tamu_tidak_ditemukan: "Guest data not found.",
    tamu_umum: "General Guest",
    rsvp_checkin: "RSVP & Check-in",
    kado_amplop: "Gifts & Envelopes",
    nama_terdaftar: "Registered Name",
    max_kuota_hadir: "Max Attendance",
    tidak_dibatasi: "Unlimited",
    rsvp: "RSVP",
    balasan_anda: "Your Reply",
    data_checkin: "Check-in Data (Guest Book)",
    sudah_checkin: "Checked-in",
    belum_checkin: "Not Checked-in",
    jumlah_hadir_aktual: "Actual Attendees",
    waktu_hadir: "Check-in Time",
    kado_fisik: "Physical Gifts",
    tidak_ada_kado_fisik: "No physical gift data.",
    amplop_digital: "Digital Envelopes",
    total_amplop_digital: "Total Digital Envelopes",
    transfer: "Transfer",
    balas_ucapan: "Reply to Wish",
    balas_ucapan_desc: "Show appreciation to guests for their wishes and prayers.",
    pilih_ucapan: "Select Wish",
    pilih_ucapan_placeholder: "Select wish...",
    tulis_balasan: "Write your reply...",
    mengirim: "Sending...",
    update_balasan: "Update Reply",
    kirim: "Send",
    belum_hadir: "Not Present",
    tamu_telah_hadir: "Guests Attended",
    laporan_checkin: "Guest Book Check-in Report",
    desc_checkin: "List of guests who have filled out the guest book or checked in via QR Code.",
    total_tamu_undangan: "Total Invited Guests (RSVP)",
    tamu_berhasil_checkin: "Successfully Checked-in Guests",
    jumlah_orang_checkin: "Number of People Checked-in",
    checkin_manual: "Manual Check-in",
    belum_ada_checkin: "No guests have checked in yet.",
    desc_checkin_manual: "Record the attendance of guests present at the event location.",
    tamu_terdaftar: "Registered Guests",
    belum_terdaftar: "Unregistered",
    pilih_tamu: "Select Guest",
    ketik_nama_tamu: "Type guest name...",
    mencari_tamu: "Searching guests...",
    tamu_tidak_ditemukan: "Guest not found.",
    masukkan_nama_tamu: "Enter guest name",
    alamat_email_tamu: "Guest email address",
    simpan_checkin: "Save Check-in",
    total_hadir: "Total Attendees",
    edit_kehadiran: "Edit Attendance",
    masukkan_jumlah_kehadiran: "Enter number of attendees",
    gift: "Gift",
    status_pending: "Pending",
    status_received: "Received",
    status_sent: "Sent",
    status_processed: "Processed",
    desc_kado_fisik: "This page displays a list of gifts sent by invited guests.",
    total_kado: "Total Gifts",
    total_pemberi_kado: "Total Gift Givers",
    cari_pengirim_kado: "Search for gift sender...",
    belum_ada_kado_fisik: "No physical gift data available yet.",
    hapus_data_kado: "Delete Gift Data",
    desc_hapus_kado: "Are you sure you want to remove this gift from the list? This action cannot be undone.",
    tanggal: "Date",
    nama_tamu: "Guest Name",
    hamba_allah: "Anonymous",
    channel: "Channel",
    nominal: "Amount",
    biaya_pg: "Payment Gateway Fee",
    total: "Total",
    nama_penerima: "Recipient Name",
    wd_fee: "WD Fee",
    dana_diterima: "Funds Received",
    tipe_transaksi: "Transaction Type",
    penarikan: "Withdrawal",
    pemasukan: "Income",
    transaksi: "Transaction",
    saldo: "Balance",
    sisa_saldo: "Remaining Balance",
    tarik_dana: "Withdraw Funds",
    pemberi_amplop_digital: "Digital Envelope Senders",
    riwayat_pemasukan: "Income History",
    riwayat_penarikan: "Withdrawal History",
    riwayat_saldo: "Balance History",
    cari_transaksi: "Search transactions...",
    belum_ada_data_x: "No {x} data available yet.",
    status_success: "Success",
    status_failed: "Failed",
    status_process: "Process",
    silakan_pilih_bank: "Please select a bank / digital wallet",
    nomor_rekening_wajib: "Account number is required",
    nama_pemilik_wajib: "Account owner name is required",
    minimal_penarikan: "Minimum withdrawal is Rp 50,000",
    saldo_tidak_mencukupi: "Your balance is insufficient",
    penarikan_dana: "Withdraw Funds",
    bank_dompet_digital: "Bank / Digital Wallet",
    pilih_bank: "Select Bank",
    memuat_bank: "Loading bank list...",
    cari_nama_bank: "Search bank name...",
    bank_tidak_ditemukan: "Bank not found.",
    nomor_rekening: "Account Number",
    placeholder_rekening: "Enter account number / phone number",
    nama_pemilik_rekening: "Account Owner Name",
    placeholder_nama_pemilik: "Name as in the bank book",
    nominal_penarikan: "Withdrawal Amount",
    saldo_kurang_alert: "Insufficient balance!",
    ringkasan_penarikan: "Withdrawal Summary",
    biaya_layanan: "Service Fee (15%)",
    total_diterima: "Total Received",
    data_sesuai: "The data above is correct"
  },
  LandingPage: {
    menu_home: "Home",
    menu_fitur: "Features",
    menu_harga: "Pricing",
    menu_tema: "Themes",
    menu_vendor: "Vendors",
    menu_login: "Sign In",
    menu_register: "Register",
    fitur_layanan: "Platform Features",

    fitur_1_title: "All-in-One Digital Invitation Platform",
    fitur_1_desc: "Every essential digital invitation feature is available at Elynk.co. Free to use and ready to share...",
    fitur_2_title: "Automated WhatsApp Broadcasts",
    fitur_2_desc: "Instantly distribute your digital invitations to all your guests via WhatsApp automatically. No more...",
    fitur_3_title: "QR Code Guest Book Check-in",
    fitur_3_desc: "Each guest receives a unique QR Code for a seamless check-in experience at your venue. On the day...",
    fitur_4_title: "Integrated Digital Envelope",
    fitur_4_desc: "Elynk offers a fully integrated digital envelope system, enabling guests to securely send cashless gifts...",
    fitur_5_title: "Flexible Custom RSVP System",
    fitur_5_desc: "Effortlessly manage your guest attendance with our fully customizable RSVP management system.",
    fitur_6_title: "Automated Event Reminders",
    fitur_6_desc: "Elynk.co’s smart reminders ensure that guests who have RSVP'd won't miss your special day...",
    fitur_7_title: "Multi-Event Access per Guest",
    fitur_7_desc: "Within a single invitation, easily manage access for different sessions (e.g., holy matrimony, reception,...",
    fitur_8_title: "Automated Gift Registry",
    fitur_8_desc: "Guests can conveniently browse, select, and purchase physical gifts directly for the host through Elynk...",
    hero_title: "The #1 Professional Digital Invitation Platform in Indonesia. Start Free Now for All Event Types.",
    hero_desc: "Manage invitations, RSVPs, automated reminders, and digital envelopes in one seamless, automated, and cost-effective platform.",
    hero_img_alt: "Digital Invitation Mockup",
    tema_tanpa_nama: "Untitled Theme",
    gratis: "Free",
    preview_btn: "Preview",
    gunakan_tema_btn: "Use Theme",
    preview_theme_title: "Elegant Theme Selections For Every Occasion",
    preview_theme_desc_1: "Every theme is meticulously designed to be modern, clean, and responsive,",
    preview_theme_desc_2: "ready to elevate your personal and professional events.",
    belum_ada_tema: "No themes available yet",
    tema_tahap_pembuatan: "Themes for this category are currently in development.",
    new_feature_title: "Every Digital Invitation Feature in One Unified Platform",
    new_feature_subtitle: "Free to use, unlimited sharing, and no expiration date.",
    new_feature_img_alt: "Elynk.co All-in-One Features",
    new_feature_heading_1: "All-in-One Digital Invitation",
    new_feature_heading_2: "Platform (FREE)",
    new_feature_desc_1: "All essential digital invitation features are fully available on Elynk.co. Free to use, unlimited sharing, and ",
    new_feature_desc_bold: "never expires",
    new_feature_list_title: "What's Included in Your Invitation:",
    new_feature_list_1: "Photo & Video Gallery",
    new_feature_list_2: "Location & Google Maps Integration",
    new_feature_list_3: "Custom Background Music",
    new_feature_list_4: "Customizable Premium Themes",
    new_feature_list_5: "Love Story Timeline",
    new_feature_list_6: "And 20+ More Features",
    new_feature_btn: "Explore all features",
    custom_rsvp_title: "Flexible Custom RSVP",
    custom_rsvp_desc_1: "Effortlessly manage guest attendance with a fully customizable RSVP system. You can tailor RSVP questions to your event's needs, define attendance statuses, and ",
    custom_rsvp_desc_bold: "limit the number of plus-ones each guest can bring.",
    custom_rsvp_list_title: "This feature helps you:",
    custom_rsvp_list_1: "Keep event capacity perfectly on track",
    custom_rsvp_list_2: "Prevent unexpected over-attendance",
    custom_rsvp_list_3: "Manage guests neatly and in full control",
    custom_rsvp_btn: "Learn more",
    custom_rsvp_img_alt: "Elynk Custom RSVP Feature",
    sebar_otomatis_title: "Automated WhatsApp Broadcast",
    sebar_otomatis_desc: "Distribute your digital invitations to all guests automatically via WhatsApp. No need to send them manually one by one—just prepare your guest list, and our system will handle the structured delivery.",
    sebar_otomatis_list_title: "The Results:",
    sebar_otomatis_list_1: "Faster invitation distribution process",
    sebar_otomatis_list_2: "Minimized delivery errors",
    sebar_otomatis_list_3: "Highly efficient for large guest lists",
    sebar_otomatis_btn: "Learn more",
    sebar_otomatis_img_alt: "Elynk Automated WhatsApp Broadcast",
    qr_checkin_title: "QR Code Guest Book Check-in",
    qr_checkin_desc: "Each guest receives a unique QR Code for a seamless check-in experience at the venue. On the day of the event, guests simply scan their QR Code to register their attendance.",
    qr_checkin_list_title: "The Benefits:",
    qr_checkin_list_1: "Faster and more organized check-in process",
    qr_checkin_list_2: "Attendance data is recorded automatically",
    qr_checkin_list_3: "Ideal for formal and professional events",
    qr_checkin_btn: "Learn more",
    qr_checkin_img_alt: "Elynk QR Code Guest Book Check-in",
    guest_split_title: "Multi-Event Access per Guest",
    guest_split_desc: "Within a single invitation, you can create multiple distinct events (e.g., holy matrimony, reception, after-party, or other exclusive sessions).",
    guest_split_list1_title: "Each guest can be configured to:",
    guest_split_list1_1: "Only be invited to specific events",
    guest_split_list1_2: "Be restricted from accessing uninvited sessions",
    guest_split_list2_title: "This feature is highly ideal for:",
    guest_split_list2_1: "Events with segmented guest lists",
    guest_split_list2_2: "Intimate weddings",
    guest_split_list2_3: "Events requiring strict access control",
    guest_split_btn: "Learn more",
    guest_split_img_alt: "Elynk Multi-Event Access per Guest",
    digital_envelope_title: "Automated Digital Envelope",
    digital_envelope_desc_1: "Elynk provides a fully integrated digital envelope system that allows your guests to securely send monetary gifts online.",
    digital_envelope_list_title: "Event hosts will receive:",
    digital_envelope_list_1: "Real-time notifications for incoming gifts",
    digital_envelope_list_2: "Clear and transparent transaction history",
    digital_envelope_list_3: "Easy and fast fund withdrawals",
    digital_envelope_desc_2: "All processes are highly secure and fully transparent.",
    digital_envelope_btn: "Learn more",
    digital_envelope_img_alt: "Elynk Automated Digital Envelope",
    physical_gift_title: "Automated Gift Registry",
    physical_gift_desc_1: "Guests can conveniently select and purchase physical gifts for the host directly through Elynk. We handle the preparation and delivery to the specified destination.",
    physical_gift_list_title: "Both guests and hosts will receive:",
    physical_gift_list_1: "Detailed delivery information",
    physical_gift_list_2: "Real-time shipment tracking links",
    physical_gift_desc_2: "No more hassle with manual gift delivery coordination.",
    physical_gift_btn: "Learn more",
    physical_gift_img_alt: "Elynk Automated Gift Registry",
    package_price_title: "Choose the Perfect Plan for Your Event",
    package_price_desc: "Start with our Free plan and upgrade anytime as your needs grow",
    select_package_btn: "Select Plan",
    faq_title: "Frequently Asked Questions",
    faq_subtitle: "Everything you need to know about Elynk.co before getting started.",
    faq_q_0: "Is there trial access?",
    faq_a_0: "Yes, you get free trial access for 3 days to try all the invitation features. Once the trial period ends, you'll need to choose a package to keep your invitation active. If no package is selected, the invitation will automatically be locked and inaccessible until you activate it.",
    faq_q_1: "Does the invitation have an expiration date?",
    faq_a_1: "There's no expiration date, so your invitation remains accessible for as long as you need. Note that one invitation is only valid for a single event, so it cannot be reused or changed for a different event.",
    faq_q_2: "Can I upgrade my package anytime?",
    faq_a_2: "Yes, you can upgrade your package anytime according to your event's needs, for example from Basic to Pro or Premium. Keep in mind that the process is one-way only, so packages cannot be downgraded back to a lower tier after upgrading.",
    faq_q_3: "Can I customize the theme based on my own design?",
    faq_a_3: "Yes. For special design needs based on your preferences, you can choose the Premium package which offers a custom design service. Our team will help bring your invitation theme to life according to the concept and references you provide.",
    faq_q_4: "Is this digital invitation only for weddings?",
    faq_a_4: "No. Elynk.co digital invitations can be used for various types of events, such as birthdays, circumcisions, aqiqah, graduations, corporate events, and family gatherings. You're free to customize the theme and content to fit your event.",
    faq_q_5: "Can I create an invitation in a language other than Indonesian?",
    faq_a_5: "Yes. Through the custom localization feature, you can create an invitation in any language you need, including foreign languages. This feature even supports regional languages, making your invitation feel more personal and suited to your event's background.",
    faq_q_6: "Can I get a refund on my payment?",
    faq_a_6: "Yes. You're entitled to a 100% refund as long as the invitation has never been used or shared with guests. Once the invitation is active and has been shared, payment cannot be refunded.",
    meta_title: "Create 100% Free & Elegant Digital Invitations | Elynk",
    meta_desc: "Create stunning digital invitations for free with Elynk. Hundreds of premium themes, automated WhatsApp sharing, and guest management tools. Fast, easy, and modern!",
    meta_title_price: "Digital Invitation Pricing Plans - Elynk.co",
    meta_desc_price: "Choose the best pricing plan for your digital invitations. Free forever plans available with full features and unlimited sharing.",
    meta_title_tema: "Elegant, Luxurious & Modern Digital Invitation Theme Catalog | Elynk",
    meta_desc_tema: "Choose from hundreds of aesthetic digital invitation designs for weddings, circumcisions, or other events. Mobile-responsive, fast-loading, and always updated.",
    no_image: "Image not available",
    produk: "Products",
    hero_desc_short: "Professional digital invitations for various events. Free to use, no expiration date, and easy to manage.",
    features: {
      "all-in-one-invitation": {
        title: "All-In-One Digital Invitation Platform",
        subtitle: "The Most Comprehensive Solution in One Platform",
        description: "Create free digital invitations with our complete feature set. An all-in-one platform for guest management, RSVP, and digital gift giving in a single app.",
        seoTitle: "Most Comprehensive Free Digital Invitation Platform",
        seoDesc: "Build digital invitations for free with full features. Manage guests, RSVPs, and digital envelopes effortlessly in one application.",
      },
      "whatsapp-broadcast": {
        title: "Automated WhatsApp Broadcast",
        subtitle: "Share Invitations Faster, Neater, and Structured",
        description: "The Automated WhatsApp Broadcast feature at Elynk.co helps you send digital invitations to multiple guests without the hassle of manual one-by-one messaging.\n\nSimply prepare your guest list, and the system will handle the automated and structured delivery process for you.",
        seoTitle: "Automated & Fast Digital Invitation Delivery via WhatsApp",
        seoDesc: "Broadcast digital invitations to thousands of WhatsApp contacts automatically. Save time, eliminate manual tasks, and ensure invitations reach your guests directly.",
      },
      "qr-check-in": {
        title: "Guest Book QR Code Check-In",
        subtitle: "Faster, Neater, and Automatically Recorded Guest Check-in",
        description: "The Guest Book QR Code Check-in feature at Elynk.co streamlines the guest registration process to be more orderly and efficient on the day of your event.\n\nEach guest receives a <strong>unique QR Code</strong> linked directly to their specific invitation data.",
        seoTitle: "Digital Guest Book with Fast QR Code Check-in",
        seoDesc: "Modernize your reception with QR Code Check-in. A digital guest book that speeds up queues and accurately records guest attendance automatically.",
      },
      "digital-envelope": {
        title: "Automated Digital Envelope",
        subtitle: "Receive Digital Gifts Securely and Conveniently",
        description: "The Automated Digital Envelope feature at Elynk.co allows guests to send monetary gifts online directly through the digital invitation.\n\nThe entire process is handled within a single integrated system, making it neater, safer, and easier to monitor.",
        seoTitle: "Digital Envelope Feature: Receive Gifts via Transfer",
        seoDesc: "Receive wedding gifts cashlessly with Digital Envelopes. Secure, practical, and directly deposited into your account. No physical gift box hassle!",
      },
      "custom-rsvp": {
        title: "What Can You Configure?",
        subtitle: "Fully Customizable RSVP Questions",
        description: "You can define your own RSVP questions based on your event needs, such as:\n\n• Confirmation of Attendance (Yes, No, or Undecided)\n• Number of Guests Attending\n• Additional Information for the Organizer\n\nAll questions can be tailored to ensure the incoming data is truly relevant.",
        seoTitle: "Most Comprehensive Custom RSVP Feature for Digital Invitations",
        seoDesc: "Manage guest attendance confirmations with RSVP forms where questions can be customized to fit your event's specific needs.",
      },
      "event-reminders": {
        title: "Automated Event Reminders",
        subtitle: "Event Reminders That Work Automatically for You",
        description: "Automated event reminders at Elynk.co ensure that guests who have RSVP'd do not forget your event schedule.\n\nThe system automatically sends reminders leading up to the big day via <strong>WhatsApp</strong> and <strong>Email</strong>. No more reminding guests manually one by one.",
        seoTitle: "Automated Event Reminder Feature: Ensure Guests Don't Forget",
        seoDesc: "Send automated reminders to guests on D-1 or hours before the event starts. Increase guest attendance on your special day with Elynk.",
      },
      "multi-event-access": {
        title: "Split Events per Guest",
        subtitle: "One Invitation, Multiple Events with Full Control",
        description: "The Split Event per Guest feature at Elynk.co allows you to create multiple event sessions within one digital invitation, such as the ceremony, reception, after party, or other exclusive sessions.\n\nNotably, <strong>each guest can only access the events specifically intended for them.</strong>",
        seoTitle: "Split Event Management: Separate Invitation Sessions per Guest",
        seoDesc: "Organize guest attendance sessions with the Split Event feature. Perfect for segregating VIP or general guests to manage crowd control efficiently.",
      },
      "gift-registry": {
        title: "Automated Gift Registry",
        subtitle: "Practical Gift Sending Without the Coordination Hassle",
        description: "The Automated Gift Registry feature at Elynk.co allows guests to select and purchase physical gifts directly through the digital invitation.\n\nElynk handles the preparation and shipping of the gift to the destination. No more manual coordination of gift delivery with guests.",
        seoTitle: "Automated Gift Registry Service: Hassle-Free Gift Giving",
        seoDesc: "Make it easy for guests who cannot attend to still send gifts via the Automated Gift Registry feature. Integrated delivery directly to your address.",
      }
    },
    price_page_heading: "Online Invitation Pricing at Elynk.co",
    price_page_subheading: "Discover the perfect digital invitation plan for your needs! We offer a wide range of stunning designs and comprehensive features, from simple invitations to full customization. Get the best service at affordable prices, including unlimited revisions and full support to ensure your invitations look perfect. Choose your plan now and make your special moments even more memorable!",
    theme_banner_title_1: "Choose and Customize",
    theme_banner_title_2: "Your Invitation Theme",
    theme_banner_desc: "No need for tedious design edits—you can switch and personalize themes effortlessly!",
    filters_btn: "Filters",
    search_theme_placeholder: "Search Theme Name",
    active_filter_label: "Active filters:",
    filter_color: "Color",
    filter_event: "Event Type",
    filter_style: "Style",
    clear_filter_btn: "Clear Filters",
    recommendation_label: "Recommended",
    search_result_label: "Search results for:",
    all_themes_label: "All Themes",
    design_label: "Designs",
    theme_not_found: "No themes found.",
    theme_not_found_desc: "Try using different keywords or filters.",
    filter_modal_title: "Filter Themes",
    filter_category_label: "Event Category",
    all_categories: "All Categories",
    filter_style_label: "Theme Style",
    all_styles: "All Styles",
    filter_color_label: "Colors",
    reset_btn: "Reset",
    apply_filter_btn: "Apply Filters",
    preview_not_available: "We're sorry, the Preview/Demo is not yet available for this theme.",
    menu_footer_title: "Menu",
  },
  Login: {
    hero_title: "The #1 Professional Digital Invitation Platform. 100% FREE for Every Occasion",
    hero_desc: "Streamline invitations, RSVPs, automated reminders, and digital gifts in one clean, automated, and unlimited free platform.",
    welcome_back: "Welcome Back",
    please_login: "Please sign in to your account",
    email_label: "Email Address",
    email_placeholder: "name@domain.com",
    email_required: "Please enter your email...",
    email_invalid: "Invalid email format",
    password_label: "Password",
    password_required: "Please enter your password...",
    forgot_password: "Forgot Password?",
    login_btn: "Sign In",
    logging_in: "Signing in...",
    or_login_with: "Or Continue With",
    redirecting: "Redirecting...",
    google_btn: "Google",
    no_account: "Don't have an account?",
    register_link: "Register",
    welcome_back_toast: "Welcome back!",
    login_failed_toast: "Incorrect Email or Password",
    google_error_toast: "Failed to redirect to Google."
  },
  Register: {
    hero_title: "The #1 Professional Digital Invitation Platform. 100% FREE for Every Occasion",
    hero_desc: "Streamline invitations, RSVPs, automated reminders, and digital gifts in one clean, automated, and unlimited free platform.",
    create_account: "Create Your Account",
    name_label: "Full Name",
    name_placeholder: "Jhon Doe",
    email_label: "Email Address",
    email_placeholder: "username@domain.com",
    password_label: "Create Password",
    confirm_label: "Confirm Password",
    agree_to: "I agree to the",
    terms_conditions: "Terms & Conditions",
    register_btn: "Get Started",
    creating_account: "Creating your account...",
    or_login_with: "Or Register With",
    or_register_with: "Or Sign Up Using",
    google_btn: "Google",
    redirecting: "Direct...",
    already_have_account: "Already have an account?",
    login_link: "Sign In",
    error_name_required: "Please enter your name...",
    error_name_min: "Name must be at least 2 characters",
    error_name_invalid: "Name can only contain letters and spaces",
    error_email_required: "Please enter your email...",
    error_email_invalid: "Please enter a valid email address",
    error_password_required: "Please enter your password...",
    error_password_min: "Password must be at least 8 characters",
    error_confirm_required: "Please confirm your password...",
    error_password_mismatch: "Passwords do not match",
    error_terms_required: "You must agree to the terms and conditions...",
    success_registration_toast: "Registration successful! Setting up your account...",
    success_login_toast: "Login successful!",
    error_auto_login_toast: "Registration successful, but automatic login failed. Please sign in manually.",
    error_registration_failed_toast: "Registration failed",
    google_coming_soon: "Google Sign-in is coming soon! 🚀"
  },
  ForgotPassword: {
    page_title: "Forgot Password",
    hero_title: "The #1 Professional Digital Invitation Platform. 100% FREE for Every Occasion",
    hero_desc: "Streamline invitations, RSVPs, automated reminders, and digital gifts in one clean, automated, and unlimited free platform.",
    form_title: "Forgot Password?",
    form_desc_1: "Enter your email address below and we will",
    form_desc_2: "send you a link to reset your password.",
    email_placeholder: "Email Address",
    timer_sec: "Sec",
    btn_send_link: "Send Reset Link",
    btn_sending: "Sending...",
    btn_wait: "Wait before resend...",
    back_to: "Back to",
    login_link: "Sign In",
    error_email_required: "Please enter your email...",
    error_email_invalid: "Invalid email format",
    success_toast: "Reset link sent to your email!",
    error_toast: "Failed to send reset link."
  },
  ResetPassword: {
    form_title: "Reset Password",
    form_subtitle: "Enter your new password below",
    label_new: "New Password",
    label_confirm: "Confirm Password",
    btn_reset: "Reset Password",
    btn_resetting: "Resetting...",
    back_to: "Back to",
    login_link: "Sign In",
    already_done_title: "Reset Password Completed",
    already_done_desc: "Your account ({email}) has already reset its password. You cannot perform a reset again at this time.",
    error_required: "All password fields are required.",
    error_min: "Password must be at least 8 characters.",
    error_mismatch: "Password and Confirm Password do not match.",
    success_toast: "Password successfully reset! Please sign in.",
    error_toast: "Failed to reset password.",
    back_to_login: "Back to Sign in"
  },
  AllInOne: {
    hero_title: "All-In-One Digital Invitation Platform (100% Free)",
    hero_subtitle: "Every Essential Digital Invitation Feature, Included",
    hero_desc: "is a powerful digital invitation platform designed to help you create <b>comprehensive</b>, <b>elegant</b>, and <b>professional</b> invitations completely free and with no time limits. <br/>",
    list_heading: "All core digital invitation features are instantly available and ready to use:",
    list_item_1: "100% Free",
    list_item_2: "Unlimited Sharing",
    list_item_3: "No Expiration Date",
    no_upgrade_needed: "You never have to upgrade just to access essential invitation features.",
    btn_create: "Create Free Now",
    meaning_title: "What Does All-In-One Mean?",
    meaning_desc: "All-in-One means you no longer need to piece together multiple tools or services. Everything you need for a digital invitation from stunning visuals and event details to seamless guest experiences is available within a single platform. Simply create an invitation, fill in your details, pick a theme, and share it with the world.",
    feature_20_title: "20+ Powerful Digital Invitation Features You Get",
    feat_l_1: "Free access to all premium themes",
    feat_l_2: "Unlimited guest name customization",
    feat_l_3: "No expiration date (Lifetime access)",
    feat_l_4: "RSVP & digital guestbook",
    feat_l_5: "Google Maps integration",
    feat_l_6: "Unlimited invitation sharing",
    feat_l_7: "Live event countdown timer",
    feat_l_8: "Google Calendar reminders",
    feat_l_9: "High-quality photo & video gallery",
    feat_l_10: "Cashless gift registry",
    feat_l_11: "Physical gift delivery coordination",
    feat_l_12: "Integrated digital envelopes",
    feat_l_13: "Hundreds of customizable background music",
    feat_r_1: "Live streaming link integration",
    feat_r_2: "Auto-scroll functionality",
    feat_r_3: "Custom typography and color schemes",
    feat_r_4: "Full theme customization",
    feat_r_5: "QR code guest check-in",
    feat_r_6: "Welcome screen & guest check-in",
    feat_r_7: "Love story timeline & event schedule",
    feat_r_8: "Co-host & 'invited by' feature",
    feat_r_9: "Invitation distribution analytics",
    feat_r_10: "Embedded event location maps",
    feat_r_11: "Reply to guest wishes",
    feat_r_12: "Unlimited content revisions",
    feat_r_13: "Drag-and-drop component layout",
    free_box_title: "Free, Unlimited,<br/>Never Expires",
    free_box_subtitle: "All the digital invitation features above are:",
    free_box_list_1: "Free to use",
    free_box_list_2: "Shareable with unlimited guests",
    free_box_list_3: "Active forever (no expiration)",
    use_elynk_1: "Use",
    use_elynk_2: "with zero time limits and absolutely no hidden fees."
  },
  AutoShare: {
    how_it_works: "How does it work?",
    step1_title: "Prepare Your Guest List",
    step1_desc: "Input your guest list along with their WhatsApp numbers directly into our secure system.",
    step2_title: "Set Up Your Message",
    step2_desc: "Define the invitation message format you want to send, complete with a personalized dynamic link for each guest.",
    step3_title: "Automated Broadcast",
    step3_desc_1: "The Elynk system will seamlessly dispatch the invitations gradually and systematically via WhatsApp.",
    step3_desc_2: "The entire process runs on autopilot without the need for manual intervention.",
    benefits_title: "What are the core benefits?",
    benefits_subtitle: "Accelerated Invitation Delivery",
    benefits_desc: "Distribute your digital invitations to hundreds or thousands of guests in a fraction of the time.",
    card1_title: "Minimized Delivery Errors",
    card1_desc: "Because the entire process is system-driven, you eliminate the risk of:",
    card1_li_1: "Sending the wrong message",
    card1_li_2: "Generating incorrect invitation links",
    card1_li_3: "Forgetting to invite specific important guests.",
    card2_title: "Highly Efficient for Scale",
    card2_desc: "This intelligent feature is incredibly ideal for:",
    card2_li_1: "Events with massive attendee lists",
    card2_li_2: "Professional corporate events and seminars",
    card2_li_3: "Users looking to significantly save time and effort",
    card3_title: "Structured & Trackable",
    card3_desc: "Every delivery action is transparently recorded within the system, allowing you to:",
    card3_li_1: "Track exactly which invitations have been delivered",
    card3_li_2: "Monitor the real-time overall delivery progress",
    card3_li_3: "Manage your complex guest list with absolute precision",
    card4_title: "Seamless Ecosystem Integration",
    card4_desc: "The automated WhatsApp broadcast connects effortlessly to:",
    card4_li_1: "Custom RSVP management",
    card4_li_2: "Automated event reminders",
    card4_li_3: "Advanced broadcast analytics & reports",
    card4_footer: "All data synchronizes flawlessly to guarantee a perfectly executed event experience."
  },
  QRCheckin: {
    how_it_works: "How does it work?",
    step1_title: "Unique QR Code for Every Guest",
    step1_desc: "Each invitation is equipped with a personalized, secure QR Code generated exclusively for that guest.",
    step2_title: "Effortless On-Site Scanning",
    step2_desc: "Upon arrival at the venue, guests simply present their QR Code to be scanned by the event staff.",
    step3_title: "Instant Attendance Logging",
    step3_desc: "Once scanned, the guest's attendance is instantly logged into the system in real-time.",
    why_use_title: "Why Should You Use<br/>QR Code Check-In?",
    without_qr_desc: "Without a Digital Check-In System, organizers often face:",
    without_qr_li_1: "Long, frustrating queues at the entrance",
    without_qr_li_2: "Errors in manual guest tracking",
    without_qr_li_3: "Difficulty in monitoring the real-time headcount",
    qr_solves_desc: "QR Code Check-In eliminates these issues completely.",
    main_benefits_title: "Core Benefits",
    benefit1_title: "Faster & Highly Organized Check-In",
    benefit1_desc: "Guests no longer need to write manually or wait in line, ensuring a smooth and elegant entry flow.",
    benefit2_title: "Automated Attendance Data",
    benefit2_desc: "Every guest who arrives is automatically recorded in the database, requiring zero manual input from your staff.",
    benefit3_title: "Ideal for Formal & Professional Events",
    benefit3_desc: "This feature is perfectly suited for:",
    benefit3_li_1: "Weddings with large guest lists",
    benefit3_li_2: "Intimate weddings requiring strict access control",
    benefit3_li_3: "Professional Corporate Events & Seminars",
    benefit4_title: "Fully Integrated Ecosystem",
    benefit4_desc: "The QR Code Guestbook seamlessly connects with:",
    benefit4_li_1: "Custom RSVP Management",
    benefit4_li_2: "Automated Event Reminders",
    benefit4_li_3: "Comprehensive Attendance Analytics",
    benefit4_footer: "All attendance data is neatly secured and accessible within a single platform."
  },
  EventReminder: {
    how_it_works: "How Does It Work?",
    step1_title: "Guests Submit RSVP",
    step1_desc: "Only guests who have explicitly confirmed their attendance will receive event reminders.",
    step2_title: "Automated Reminders",
    step2_desc: "The system automatically schedules and dispatches reminders at your pre-configured intervals.",
    step3_title: "Via WhatsApp & Email",
    step3_desc: "Reminders are strategically delivered through multiple channels to guarantee high visibility.",
    why_important_title: "Why is this feature crucial?",
    without_reminder_desc: "Without automated reminders, organizers often face:",
    problem_1: "Guests forgetting the<br/>exact date or time",
    problem_2: "Actual attendance falling<br/>short of confirmed RSVPs",
    problem_3: "Hosts struggling with tedious<br/>manual follow-up tasks",
    solution_desc: "Automated Event Reminders elegantly<br /> eliminate all these issues.",
    main_benefits_title: "Core Benefits",
    card1_title: "Drastically Reduce<br class='hidden md:block' /> No-Shows",
    card1_desc: "Guests receive timely notifications, ensuring they are fully prepared to attend your event.",
    card2_title: "Maximize Guest<br class='hidden md:block' /> Attendance Rates",
    card2_desc: "Consistent, polite reminders significantly increase the likelihood that confirmed guests actually arrive.",
    card3_title: "Zero Manual Follow-Up",
    card3_desc_1: "You no longer have to waste time:",
    card3_li_1: "Sending individual reminder texts",
    card3_li_2: "Calling guests days before the event",
    card3_desc_2: "The entire process is fully handled by our system.",
    card4_title: "Deeply Integrated System",
    card4_desc_1: "Automated reminders work in perfect harmony with:",
    card4_li_1: "Custom RSVP module",
    card4_li_2: "Automated WhatsApp Broadcasts",
    card4_li_3: "QR Code Guest Book Check-in",
    card4_desc_2: "Attendance data and schedules remain perfectly synchronized at all times.",
    card5_title: "Perfectly Suited For",
    card5_li_1: "Weddings & intimate ceremonies",
    card5_li_2: "Family reunions & gatherings",
    card5_li_3: "Community events & meetups",
    card5_li_4: "Professional corporate events",
    card5_desc: "This feature ensures every event runs smoothly and predictably."
  },
  MultiEvent: {
    how_it_works: "How Does It Work?",
    step1_title: "Create Multiple Events in One Invitation",
    step1_desc: "Easily add multiple event sessions with distinct times, locations, and exclusive details.",
    step2_title: "Granular Guest Access Control",
    step2_desc: "Precisely define which guests are invited to specific sessions and strictly limit access to others.",
    step3_title: "Highly Personalized Display",
    step3_desc: "Guests will only view the event information that is highly relevant and strictly intended for them.",
    why_important_title: "Why is this Feature Crucial?",
    without_feature_desc: "Without strict access management, organizers often face:",
    problem_1: "Guests unexpectedly attending private sessions",
    problem_2: "Massive confusion regarding schedules and venues",
    problem_3: "Compromised privacy for highly exclusive events",
    solution_desc: "Our Multi-Event Split feature keeps your entire event completely controlled and secure.",
    main_benefits_title: "Core Benefits",
    card1_title: "Strict Access Control",
    card1_desc: "Ensures guests can only attend the specific sessions they have been formally invited to.",
    card2_title: "Clean & Professional Aesthetic",
    card2_desc: "Invitations look incredibly organized as each guest receives a tailored, clutter-free itinerary.",
    card3_title: "Uncompromised Privacy",
    card3_desc: "Guarantees that sensitive sessions—such as holy matrimony or VIP dinners—remain entirely exclusive.",
    card4_title: "Perfectly Suited For",
    card4_li_1: "Events requiring complex guest segmentation",
    card4_li_2: "Intimate weddings with strict venue capacities",
    card4_li_3: "Professional events demanding rigorous access control",
    card5_title: "Seamless Ecosystem Integration",
    card5_desc: "The Multi-Event Split connects flawlessly with:",
    card5_li_1: "Custom RSVP module",
    card5_li_2: "QR Code Guest Book Check-in",
    card5_li_3: "Automated Event Reminders",
    card5_footer: "All guest access and attendance data are constantly synchronized."
  },
  GiftRegistry: {
    how_it_works: "How Does It Work?",
    step1_title: "Guests Select a Gift",
    step1_desc: "Guests can seamlessly browse and purchase available gifts directly from your digital invitation.",
    step2_title: "Elynk Prepares the Gift",
    step2_desc: "Upon successful payment, our team carefully prepares the gift exactly as ordered.",
    step3_title: "Direct Delivery to Your Door",
    step3_desc: "Gifts are securely shipped directly to the event host's designated address.",
    transparent_title: "Fully Transparent & Trackable",
    transparent_desc_1: "Both the guests and the event host will receive:",
    transparent_li_1: "Detailed delivery status updates",
    transparent_li_2: "Real-time shipment tracking links",
    transparent_desc_2: "Everyone stays informed throughout the entire delivery process effortlessly.",
    main_benefits_title: "Core Benefits",
    card1_title: "Zero Manual Coordination",
    card1_desc_1: "Say goodbye to:",
    card1_li_1: "Asking for shipping addresses",
    card1_li_2: "Organizing separate couriers",
    card1_li_3: "Constantly confirming delivery statuses",
    card1_desc_2: "The entire process is handled by our system.",
    card2_title: "Effortless Guest Experience",
    card2_desc: "Guests can thoughtfully send physical gifts even if they cannot attend the event in person.",
    card3_title: "Organized for the Host",
    card3_desc: "Hosts receive their gifts via a highly organized, fully tracked delivery system.",
    card4_title: "Perfectly Suited For",
    card4_li_1: "Weddings & family gatherings",
    card4_li_2: "Events with out-of-town guests",
    card4_li_3: "Professional & corporate events",
    card4_li_4: "Events with massive attendee lists",
    card5_title: "Seamless Ecosystem Integration",
    card5_desc_1: "The Automated Gift Registry connects instantly with:",
    card5_li_1: "Automated Digital Envelope",
    card5_li_2: "Automated WhatsApp Broadcasts",
    card5_li_3: "Comprehensive Gift Analytics Dashboard",
    card5_desc_2: "All gifts are securely recorded within a single platform."
  },
  MenuTypeSetting: {
    description: "Choose the navigation menu style shown on the invitation.",
    default_name: "Default",
    default_desc: "Floating menu with cover photo.",
    liquid_glass_desc: "Floating menu with transparent background.",
    load_failed: "Failed to load menu types.",
    save: "Save Changes",
    saving: "Saving...",
    save_success: "Menu type updated successfully.",
    save_failed: "Failed to save menu type."
  },
  InvitationMenu: {
    event_label: "Event",
    rsvp_label: "RSVP",
    hadiah_label: "Gift",
    physical_gift_label: "Physical Gift",
    language_label: "Language",
    wish_label: "Wishes",
    qr_label: "QR Code",
    gift_label: "Gift",
    scroll_label: "Scroll",
    gift_modal_title: "Choose Physical Gift"
  },
  MenuPanel: {
    edit_box: "Edit Box",
    tab_components: "Components",
    tab_settings: "Settings",
    tab_preview: "Preview",
    tab_upgrade: "Upgrade",
    tab_share: "Share",
    edit: "Edit",
    edit_background: "Edit Background",
    edit_box_art: "Edit Box Art",
    under_maintenance: "is under maintenance",
    preview_title: "Preview",
    preview_desc: "View your invitation preview",
    activation_title: "Activation",
    activation_desc: "Activate your invitation",
    share_title: "Share",
    share_desc: "Share your invitation"
  },
  SortableBox: {
    edit_box: "Edit Box",
    delete_box: "Delete Box",
    show_box: "Show Box",
    drag_placeholder: "Drag components to this box",
    add_component: "Add Component"
  },
  SettingsRealtimeEdit: {
    menu_theme: "Theme",
    menu_music: "Music",
    menu_colors: "Theme Colors",
    menu_fonts: "Theme Fonts",
    menu_autoscroll: "Auto Scroll",
    menu_menu_type: "Menu Type",
    menu_whatsapp: "WhatsApp Preview",
    desc_whatsapp: "See how your invitation looks on WhatsApp"
  },
  PhysicalGift: {
    error_min_gift: "Please select at least 1 gift.",
    error_invitation_not_ready: "Invitation data is not ready. Please refresh the page."
  },
  CheckoutGift: {
    title: "Choose Another Gift",
    info_banner: "After payment, the invitation host will receive a notification and our team will prepare and deliver the gift according to the host's confirmation. Guests will receive a <strong>tracking link</strong> to monitor the gift's delivery status.",
    items_title: "Items",
    aria_remove_item: "Remove {name}",
    payment_summary_title: "Payment Summary",
    total_purchase: "Total Purchase",
    shipping_paid_by_recipient: "Shipping paid by recipient",
    shipping: "Shipping",
    shipping_discount: "Shipping Discount",
    total_payment: "Total Payment",
    greeting_section_title: "Message (Optional)",
    greeting_label: "Message",
    greeting_placeholder: "Write a message for the couple",
    agree_terms_label: "I agree to elynk.co's terms of service",
    agree_terms_error: "You must agree to the terms of service first",
    privacy_note: "Your data is kept confidential and will only be used for confirmation purposes",
    footer_info: "After payment you will receive a tracking link via email",
    total_label: "Total",
    btn_proceed_payment: "Proceed to Payment",
    toast_success: "Checkout data saved, please proceed to payment.",
    toast_error: "An error occurred, please try again."
  },
  ListGiftProduct: {
    info_banner: "Physical Gift Registry allows guests to conveniently send physical gifts directly from the digital invitation. Once the payment is confirmed, the event host will receive an instant <span class='font-bold'>notification</span>. Our team will then securely prepare and deliver the gift according to the host's preferences. Guests will receive a <span class='font-bold'>tracking link</span> to monitor their gift's delivery status.",
    aria_view_detail: "View details of",
    btn_selected: "Selected",
    btn_select_gift: "Select Gift",
    footer_info: "After a successful payment, you will receive a tracking link via email.",
    total: "Total",
    btn_proceed_payment: "Proceed to Payment"
  },
  LayarSapa: {
    waiting_guest: "Waiting for Guest...",
    welcome: "Welcome",
    thank_you: "Thank You for Attending Our Event",
    dear: "Dear:"
  },
  GuestQR: {
    page_title: "Guest QR Code Ticket",
    default_event_name: "Wedding Invitation",
    success_download: "QR Code ticket downloaded successfully!",
    error_download: "Failed to download QR Code.",
    invalid_qr: "Invalid QR Code",
    invalid_qr_desc: "This invitation link is missing the Guest Code.",
    btn_back: "Back",
    scan_title: "Guest Book Check-in Scan",
    view_invitation: "View Invitation",
    scan_instruction: "Please present this QR Code to the event staff before entering the venue",
    btn_download: "Download"
  },
  GuestQrCamera: {
    btn_back: "Back",
    page_title: "Scan Invitation QR",
    page_instruction: "Please point your camera at the QR code on your invitation to check in.",
    box_instruction: "Position QR code inside the box",
    status_validating: "Validating Event Data...",
    status_camera_init: "Preparing Camera...",
    status_processing: "Processing Check-in...",
    status_wait: "Please wait a moment",
    error_event_not_found: "Event data not found!",
    error_missing_code: "Guest Code not found in URL! Open the QR Code menu from your Invitation.",
    error_invalid_qr: "Invalid QR Code. Please scan the QR Code placed at the event entrance!",
    loading_verify_location: "Verifying Your Location...",
    info_already_checked_in: "You have already Checked-in",
    info_redirecting: "Redirecting to success page.",
    success_location_match: "Location Matched! Proceeding to confirmation.",
    error_fetch_data: "Failed to fetch guest data. Please try again.",
    error_camera_access: "Failed to access camera. Please ensure the browser has camera permissions."
  },
  GuestSubmit: {
    guest_name_default: "Guest",
    toast_error_corrupt: "Guest data link is corrupted.",
    event_name_default: "Our Event",
    toast_error_session: "Invalid session. Please scan again.",
    toast_success_checkin: "Check-in Successful!",
    toast_error_checkin: "Failed to process Check-in. Please try again.",
    toast_error_incomplete: "Incomplete data. Returning to camera...",
    btn_cancel: "Cancel Scan",
    title: "Confirm Attendance",
    location_notice: "You have been detected at the event location.<br/>Please ensure the total number of guests accompanying you is correct before confirming.",
    subtitle: "Guest Self Check-in",
    label_name: "Your Name",
    label_pax: "Total Attending Guests",
    label_pax_unit: "People",
    btn_processing: "Processing...",
    btn_submit: "Complete Check-in",

  },
  GuestSuccess: {
    page_title: "Check-in Success",
    success_title: "CHECK-IN SUCCESSFUL",
    seconds: "Seconds",
    success_desc: "Congratulations, you have successfully scanned the QR Code<br/>to Check-in to the Venue",
    btn_back: "Back to Invitation"
  },
  AdminSubmitCheckin: {
    page_title: "Check-in Confirmation",
    toast_error_corrupt: "Guest data link is corrupted.",
    event_name_default: "Wedding Invitation",
    toast_error_session: "Invalid ID data / Session expired",
    toast_success_checkin: "successfully checked in!",
    toast_success_desc: "Thank you for your confirmation.",
    toast_error_update: "Failed to update data. (Ensure the camera scan has called the POST API beforehand).",
    toast_error_incomplete: "Incomplete URL data.",
    btn_back: "Back to Scanner",
    title: "Submit Guest Book",
    valid_qr_notice: "Valid QR Code Data!<br/>Ensure the total number of guests is correct before submitting.",
    view_invitation: "View Invitation",
    label_name: "Guest Name",
    label_pax: "Total Attending",
    label_pax_unit: "People",
    btn_processing: "Saving Data...",
    btn_submit: "Submit Check-in"
  },
  AdminQrCamera: {
    toast_wrong_event: "This QR Code belongs to a different event!",
    toast_verifying: "Verifying Guest...",
    toast_already_checked_in: "Guest has already checked in",
    toast_redirecting: "Redirecting to success screen.",
    toast_qr_valid: "Valid QR! Proceeding to confirmation.",
    toast_invalid_qr: "Invalid QR Code",
    toast_camera_error: "Failed to access camera. Please ensure your browser has camera permissions.",
    btn_back: "Back",
    title: "Scan Guest QRCode",
    instruction: "Point the camera at the QRCode brought by the Guest",
    status_validating: "Validating Event Data...",
    status_camera_init: "Initializing Camera...",
    status_processing: "Processing Check-in..."
  },
  AdminSuccess: {
    page_title: "Check-in Success",
    success_title: "CHECK-IN SUCCESSFUL",
    seconds: "Seconds",
    success_desc: "Guest successfully confirmed.<br/>Redirecting back to the Camera Scanner...",
    btn_next_scan: "Continue Next Scan"
  },
  Notification: {
    "notifikasi": "Notifications",
    "tandai_semua_dibaca": "Mark all as read",
    "memuat": "Loading...",
    "belum_ada_pemberitahuan": "No notifications yet",
    "detail_pemberitahuan": "Notification Details",
    "judul": "Title",
    "isi_pesan": "Message Content",
    "tutup": "Close",
    "baru_saja": "Just now",
    "menit_lalu": "mins ago",
    "jam_lalu": "hrs ago",
    "hari_lalu": "days ago"
  },
  AddEvent: {
    title: "Create Digital Invitation",
    subtitle: "Select Event Type",
    step: "Step 1 of 5",
    default_desc: "Custom invitation for all types of events",
    fill_data_subtitle: "Fill in Some Data",
    step_2: "Step 2 of 5",
    note_adjustable: "Note: All Data Can Be Adjusted Later",
    digital_invitation: "Digital Invitation",
    your_event: "Your Event",
    subtitle_theme: "Select Invitation Theme",
    step_3: "Step 3 of 5",
    note_theme_adjustable: "Note: The theme can be changed later via the dashboard.",
    auth_subtitle: "Sign In to Continue",
    step_4: "Step 4 of 5",
    auth_ready_title: "Your Invitation is Ready",
    auth_ready_desc: "Sign in to save and continue",
    auth_ready_notice: "Your invitation is ready — sign in to save it.",
    invitation_label: "Invitation",
    name_label: "Name",
    date_label: "Date",
    theme_label: "Theme",
    theme_loading: "Loading Theme...",
    auth_google_btn: "Continue with Google",
    auth_email_btn: "Continue with Email",
    submit_auth_btn: "Sign In & Continue",
    subtitle_pricing: "Choose Pricing Plan",
    step_5: "Step 5 of 5",
    agreement_text: "By creating an event, the user agrees to the ",
    btn_create_invitation: "Create Invitation",
    selected_theme: "Selected Theme",
    data_security_notice: "Your data is secure & only used for this invitation.",
  },
  Checkout: {
    data_tidak_ditemukan: "Transaction data not found",
    lengkapi_data: "Please fill in Name, Email, and Whatsapp.",
    error_data_order: "An error occurred with order data.",
    invoice_berhasil: "Invoice successfully created, redirecting...",
    gagal_link: "Failed to get payment link.",
    gagal_proses: "Failed to process payment. Please try again.",

    item_title: "Item",
    paket_topup_ai: "AI Top Up Package",
    paket_limit_sebar: "Broadcast Limit Package",
    kredit: "Credits",
    pesan: "Messages",

    ringkasan_pembayaran: "Payment Summary",
    kredit_ai: "AI Credits",
    paket_limit: "Limit Package",
    biaya_layanan: "Service Fee",
    total_pembayaran: "Total Payment",

    checkout_title: "Checkout",
    nama_lengkap: "Full Name",
    placeholder_nama: "Enter your name...",
    email: "Email",
    placeholder_email: "Enter your email..",
    nomor_whatsapp: "Whatsapp Number",
    placeholder_whatsapp: "Enter your Whatsapp number...",

    memproses: "Processing Invoice...",
    lanjut_pembayaran: "Continue Payment",
    payment_summary: "Payment Summary",
    current_package_discount: "Current Package Discount",
    service_fee: "Service Fee",
    total_payment: "Total Payment",
    full_name: "Full Name",
    whatsapp: "WhatsApp Number",
    search_country: "Search country or code...",
    country_not_found: "Country not found",
    proceed_payment: "Proceed to Payment",
    loading_package: "Loading Package...",
    redirect_payment: "Redirecting to payment page...",
    checkout_success: "Checkout successfully recorded!",
    fill_required: "Please fill in your Name, Email, and WhatsApp.",
    promo_title: "Have a Promo Code?",
    promo_placeholder: "Enter coupon code...",
    promo_apply: "Apply",
    promo_success: "Coupon applied successfully!",
    promo_invalid: "Invalid coupon.",
    promo_removed: "Coupon removed.",
    promo_active: "Coupon Active!",
    promo_discount: "Promo Discount"
  },
  CheckoutSuccess: {
    title: "Payment Successful",
    subtitle: "Congratulations! Your payment has been successfully validated",
    redirecting_in: "Redirecting automatically in",
    seconds: "seconds...",
    waiting_data: "Waiting for data confirmation...",
    back_button: "Go Back",
  },
  CheckoutFailed: {
    title: "Payment Failed",
    description: "Sorry, your transaction could not be processed or was cancelled. Don't worry, your balance has not been deducted.",
    order_details: "Order Details",
    ai_package: "AI Top Up Package",
    limit_package: "Limit Package",
    messages: "Messages",
    credits: "Credits",
    status: "Status: Unpaid / Expired",
    retry_button: "Try Again",
    dashboard_button: "To Dashboard",
    need_help: "Need help?",
    contact_cs: "Contact our CS"
  },
  ComponentOrder: {
    perubahan_dibatalkan: "Order changes cancelled",
    tidak_ada_data_disimpan: "No data available to save",
    komponen_baru: "New Component",
    belum_dapat_diubah: "Visibility of new components cannot be changed yet",
    dihapus_dari_sesi: "removed from this session",
    box_tidak_ditemukan: "Box not found",
    pilih_dahulu: "Please select a component first",
    tambah_box: "Add Box",
    simpan_susunan: "Save Order",
    tambah_komponen_ke: "Add Component to",
    tambah_komponen_di_atas: "Add Component Above",
    tambah_komponen_di_bawah: "Add Component Below",
    pilih_komponen_baru: "Select New Component",
    pilih_component: "Select Component",
    cari_komponen: "Search component...",
    tidak_ditemukan: "Component not found.",
    tambah_komponen: "Add Component",
    hapus_komponen: "Delete Component",
    hapus_komponen_desc: "Delete the component",
    dari_box_desc: "from the box? This action cannot be undone.",
    hapus_komponen_default: "Delete this component from the box? This action cannot be undone.",
    hapus_box: "Delete Box",
    hapus_desc: "Delete",
    tidak_dapat_dibatalkan: "This action cannot be undone.",
    hapus_box_default: "Delete this box? This action cannot be undone.",
    bahasa: "Language",
    bahasa_default: "Default Language",
    belum_ada_terjemahan: "No translations yet",
    tambah_terjemahan_baru: "Add New Translation",
    kelola_bahasa: "Manage Language Translations",
    belum_ada_terjemahan_desc: "No language translations have been added yet",
    pilih_bahasa: "Select language",
    semua_bahasa_ditambahkan: "All languages have already been added",
    hapus_bahasa: "Delete Language",
    hapus_bahasa_desc: "Delete language translation",
    tampilkan_komponen: "Show Component",
    komponen_disembunyikan: "This component is hidden in the preview",
    smart_localization: "Smart Localization",
    rekomendasi_bahasa_default: "Recommendation: Complete the default language first",
    ketik_pilih_bahasa: "Type or select a language...",
    buat_baru: "Create New",
    custom_label: "Custom",
    tidak_ada_bahasa_di_daftar: 'No language "{query}" in the list',
    bahasa_sudah_ditambahkan: "This language has already been added",
    bahasa_sedang_diterjemahkan: "This language is still being translated, content may not be complete yet",
    tidak_ada_bahasa_lain: "No other languages in the list",
    smart_localization_desc_before: "Complete the default language text first. Languages from the list will be",
    smart_localization_desc_bold_auto: "automatically translated",
    smart_localization_desc_middle: "and can be edited per language, while",
    smart_localization_desc_bold_custom: "custom",
    smart_localization_desc_after: "languages are not translated automatically.",
    lang_en: "English",
    lang_ko: "Korean",
    lang_zh: "Mandarin",
    lang_ar: "Arabic",
    lang_id: "Indonesian",
    lang_ms: "Malay",
    lang_ja: "Japanese",
    lang_th: "Thai",
    lang_vi: "Vietnamese",
    lang_hi: "Hindi",
    lang_es: "Spanish",
    lang_fr: "French",
    lang_de: "German",
    lang_nl: "Dutch",
    lang_pt: "Portuguese",
    lang_ru: "Russian",
  },
  Payment: {
    success_title: "Payment Successful",
    success_desc: "Congratulations! Your payment has been successfully validated.",
  },
  Vendor: {
    nomor_identitas: "ID Number (KTP/Passport)",
    placeholder_identitas: "Example: 5101... or A1234...",
    err_identitas: "ID number must be at least 5 characters",
    identitas: "Identity",
    bisnis: "Business",
    kontak_sosial: "Contact & Social",
    portfolio_submit: "Portfolio + Submit",
    form_bisnis_coming_soon: "Business Form (Coming Soon)",
    form_kontak_coming_soon: "Contact Form (Coming Soon)",
    form_portfolio_coming_soon: "Portfolio Form (Coming Soon)",
    simpan_draft: "Save draft",
    draft_dimuat: "Previous draft successfully loaded. (Image files need to be re-uploaded)",
    draft_disimpan: "Draft successfully saved to your browser!",
    lanjut_ke: "Proceed to",
    kirim_pendaftaran: "Submit Registration",
    verifikasi_identitas_title: "Business owner identity verification.",
    data_bersifat: "This data is",
    privat: "private",
    verifikasi_identitas_desc: "and will only be seen by the Elynk admin team for verification. It will not be shown to the public.",
    nama_lengkap_ktp: "Full Name (as per ID)",
    contoh_nama: "Example: John Doe",
    tanggal_lahir: "Date of Birth",
    nomor_ktp_nik: "ID / NIK Number",
    disimpan_terenkripsi: "Stored encrypted",
    jenis_kelamin: "Gender",
    laki_laki: "Male",
    perempuan: "Female",
    alamat_ktp: "Address as per ID",
    placeholder_alamat: "123 Main Street, City, Country",
    daftar_sebagai_vendor: "Register as a Vendor",
    lengkapi_data_bisnis: "Complete your business details to start joining the Elynk ecosystem.",
    nama_bisnis: "Business Name / Brand",
    tahun_berdiri: "Year Established",
    kategori_bisnis: "Main Business Category",
    pilih_min_1: "Select min 1, multi-select allowed",
    deskripsi_bisnis: "Business Description",
    min_100_karakter: "Min 100 characters",
    provinsi_utama: "Main Province",
    kota_operasi: "City / Regency Operations",
    harga_mulai: "Starting Price (IDR)",
    harga_maksimal: "Maximum Price (IDR)",
    logo_bisnis: "Business Logo",
    banner_bisnis: "Banner / Header Photo",
    kembali: "Back",
    klik_atau_drop: "Click or drop file",
    contoh_provinsi: "Example: DKI Jakarta",
    contoh_kota: "Example: Jakarta Selatan, Bandung",
    placeholder_deskripsi: "Briefly explain about your business...",
    info_kontak_publik: "This contact will appear on your public profile once approved. Ensure WhatsApp is active - clients will contact you here.",
    kontak_utama: "Main Contact",
    no_whatsapp: "Business WhatsApp Number",
    email_bisnis: "Business Email",
    format_internasional: "International format - will be verified via OTP",
    berbeda_email_login: "Can be different from login email",
    telepon_sekunder: "Secondary Phone Number",
    jam_operasional: "Operating Hours",
    opsional: "optional",
    alamat_kantor: "Office / Studio Address",
    alamat_lengkap: "Full Address",
    kode_pos: "Postal Code",
    pin_lokasi: "Location Pin (Google Maps)",
    drag_pin: "Drag pin to adjust - optional but recommended",
    sosmed_website: "Social Media & Website",
    tambah: "+ Add",
    pilih_jenis: "Select type",
    username_url: "Username or URL",
    rekening_bank: "Bank Account",
    opsional_privat: "(optional - will not be public)",
    bank: "Bank",
    no_rekening: "Account Number",
    nama_pemilik: "Account Holder Name",
    keperluan_transaksi: "Required for future marketplace/transaction features",
    provinsi: "Province",
    kota_kab: "City / Regency",
    pilih_bank: "Select Bank",
    contoh_jam_operasional: "Monday - Saturday : 09.00 AM - 06.00 PM",
    portfolio_awal: "Initial Portfolio",
    info_portfolio: "Upload at least 1 portfolio as proof of your actual work.",
    judul_portfolio: "Portfolio / Project Title",
    kategori_portfolio: "Category",
    tanggal_event: "Event Date",
    lokasi_event: "Event Location",
    foto_portfolio: "Portfolio Photos",
    persetujuan_submit: "Agreement & Submit Application",
    info_review_admin: "The Elynk admin team will review your application within 2x24 working hours. The decision notification will be sent via email.",
    setuju_snk: "I agree to the Terms & Conditions of the Elynk.co platform",
    setuju_data_benar: "I declare that all provided data is true and accountable",
    setuju_banned: "I understand Elynk reserves the right to reject/suspend the account if proven violating",
    setuju_moderasi: "I agree to the product content moderation policy by the admin",
    penting: "Important",
    info_penting: "If the application is rejected, your account cannot reapply as a vendor. Ensure all data is complete and accurate before submitting.",
    eskripsi_portfolio: "Description",
    maks_80_karakter: "Max 80 characters",
    drag_foto: "Drag photos here",
    klik_pilih_foto: "or click to select • min 1, max 20 photos",
    sukses_judul: "Application Submitted Successfully!",
    sukses_deskripsi: "Thank you for joining Elynk.co. Your profile is currently being curated by our admin team.",
    sukses_estimasi: "This process usually takes a maximum of 2x24 working hours. We will notify you via email once your profile is approved.",
    tombol_dashboard: "Back to Dashboard",
    estimasi_waktu: "Estimated Waiting Time",
    mengirim: "Sending Data",
    err_judul_portfolio: "Portfolio title is required (max 80 chars)",
    err_foto_portfolio: "Must upload at least 1 portfolio photo",
    err_wajib_centang: "You must agree to this statement",
    err_url_wajib: "Required",
    err_whatsapp: "Invalid WhatsApp number",
    err_email: "Invalid email format",
    err_sosmed: "Minimum 1 social media or website",
    err_nama_lengkap: "Full name must be at least 3 characters",
    err_tanggal_lahir: "Date of birth is required",
    err_nik: "ID/NIK must be exactly 16 digits",
    err_jenis_kelamin: "Please select a gender",
    err_alamat: "Address is too short, please complete it",
    err_nama_bisnis: "Business name must be at least 3 characters",
    err_tahun_berdiri: "Invalid established year",
    err_kategori: "Select at least 1 business category",
    err_deskripsi: "Business description must be at least 100 characters",
    err_provinsi: "Select main province",
    err_kota: "Select at least 1 city of operation",
    err_harga_mulai: "Starting price is required",
    memuat: "Memeriksa Status"
  },
  VendorSidebar: {
    menu_title: "Main Menu",
    settings_title: "Configuration",
    dashboard: "Dashboard",
    business_profile: "Business Profile",
    products: "My Products",
    portfolio: "Portfolio",
    reviews: "Customer Reviews",
    analytics: "Analytics",
    settings: "Account Settings",
    view_public_profile: "View Public Profile",
    back_to_admin: "Back to Admin",
    active: "Active",
    pending: "Pending Approval",
    paused: "Paused"
  },
  VendorDashboard: {
    welcome_back: "Welcome back,",
    btn_portfolio: "Portfolio",
    btn_new_product: "New Product",
    stat_pageview: "Pageviews (30 Days)",
    stat_unique_visitors: "Unique Visitors",
    stat_clicks: "Contact Clicks",
    stat_rating: "Average Rating",
    stat_products: "Active Products",
    default_visitor_breakdown: "0% guest · 0% login",
    chart_title: "Traffic & Interaction Chart",
    chart_subtitle: "Last 30 Days Period",
    tab_pageview: "Pageview",
    tab_clicks: "Contact Clicks",
    grade_title: "Vendor Grade",
    suggestions_title: "Suggestions for You",
    no_suggestions: "No suggestions at the moment.",
    view_grade_history: "View grade history →",
    reminder_portfolio_title: "Portfolio Reminder",
    btn_upload_now: "+ Upload now",
    contact_analysis_title: "Contact Channel Analysis",
    no_contact_data: "No contact click data for this period.",
    top_products_title: "Top Popular Products",
    views: "views",
    no_top_products: "No popular product data yet",
    traffic_sources_title: "Main Traffic Sources",
    no_traffic_sources: "No traffic source data yet",
    latest_product_status_title: "Latest Product Status",
    no_registered_products: "No registered products yet",
    clicks: "clicks",
    recent_activities_title: "Recent Activities",
    no_recent_activities: "No recent activities",
    error_load_title: "Failed to Load Dashboard",
    btn_reload: "Reload Page",
    error_no_data: "Dashboard data is unavailable",
    error_network: "A network error occurred while loading data."
  },
  ProductForm: {
    basic_info_title: "Basic Information",
    label_title: "Product / Package Title",
    max_chars: "Max",
    characters: "characters",
    label_category: "Category",
    cat_photographer: "Photographer",
    cat_mua: "Make Up Artist",
    cat_venue: "Venue",
    cat_entertainment: "Entertainment",
    label_status: "Availability Status",
    status_active: "Active",
    status_unavailable: "Unavailable",
    label_description: "Product Description",
    prompt_link: "Enter URL Link (e.g., https://google.com):",
    description_hint: "Min 150 characters · rich text editor",
    price_title: "Price",
    label_price_type: "Price Type",
    price_from: "Starting from",
    price_fixed: "Fixed",
    price_contact: "Contact us",
    label_price_value: "Price (IDR)",
    sidebar_action_title: "Action",
    btn_submit_review: "Submit for Review",
    btn_save_draft: "Save draft",
    btn_preview: "Preview",
    info_after_submit_bold: "After submit:",
    info_after_submit_desc: "Product enters admin queue. Estimated review 2x24 working hours. Old version remains public during review.",
    sidebar_checklist_title: "Completeness Checklist",
    check_title_cat: "Title",
    check_desc: "Description (320 char.)",
    check_price: "Price",
    check_images: "3 images uploaded",
    check_list: "Included/excluded list",
    check_faq: "FAQ (recommended)",
    check_tags: "Tag (recommended)",
    media_title: "Product Images",
    photo: "photos",
    label_primary: "primary",
    media_hint: "Min 1, max 10 · drag-and-drop to reorder",
    inclusions_title: "Inclusions & Exclusions",
    label_included: "Included in package",
    label_excluded: "Not Included",
    btn_add_item: "Add item",
    label_optional: "optional",
    btn_add_faq: "Add FAQ",
    label_question: "Question",
    label_answer: "Answer",
    label_estimate: "Estimated Processing Time",
    label_tags: "Tag / Keywords",
    draft_saved_success: "Draft successfully saved locally!",
    available_slots: "Available slots",
    of: "of",
    create_new_product: "Create New Product",
    draft_not_submitted: "Draft · not submitted",
    draft_last_update: "Last update:",
    btn_back_to_list: "Back to Product List",
    edit_product_id: "Product ID:",
    edit_title: "Update Service Package",
    edit_mode_badge: "Edit / Update Mode",
  },
  Profile: {
    title: "Business Profile",
    completion_prefix: "Profile completion:",
    completion_suffix: "contributes 57/60 to grade score",
    btn_preview: "Preview public profile",
    btn_save: "Save changes",
    tab_general: "General",
    tab_area: "Service Area",
    tab_social: "Social Media",
    score_title: "Completion Score",
    check_logo_banner: "Logo & banner",
    check_desc: "Description (142 chars)",
    check_category: "Category & area",
    check_price: "Price range",
    check_social: "Min 1 social media",
    check_tiktok: "TikTok (optional)",
    info_title: "Changes Live Immediately",
    info_desc_1: "Updating business info (description, price, banner, category, area, social media)",
    info_desc_bold: "does not require admin approval",
    info_desc_2: "changes are instantly live on your public profile after saving.",
    media_title: "Banner & Logo",
    btn_change_banner: "Change banner",
    logo_title: "Business Logo",
    btn_upload_new: "Upload new",
    btn_delete: "Delete",
    basic_info_title: "Basic Information",
    label_biz_name: "Business Name",
    label_category: "Business Category",
    btn_add_category: "Add category",
    label_desc: "Business Description",
    label_year: "Year Established",
    label_slug: "URL Slug",
    pricing_title: "Pricing & Services",
    label_price_min: "Starting Price",
    label_price_max: "Maximum Price",
    service_prov_title: "Operational Province",
    service_prov_desc: "Select one or more provinces where you operate.",
    btn_add_prov: "Add province",
    service_quick_add_prov: "Quick add (popular provinces)",
    service_city_title: "Service City / Regency",
    service_city_desc: "Cities you serve. Client search filters will follow this list.",
    btn_add_city: "Add city",
    service_quick_add_city: "Quick add (popular cities)",
    service_address_title: "Office / Studio Address",
    service_address_desc: "This address does not appear on your public profile, it is for internal verification only.",
    label_full_address: "Full Address",
    label_city: "City",
    label_postal: "Postal Code",
    contact_title: "Main Contact",
    contact_desc: "Appears on public profile · protected by gated contact (only logged-in users can view).",
    label_wa: "Business WhatsApp Number",
    wa_note: "Changing this number requires re-verification via OTP",
    label_email: "Business Email",
    label_hours: "Operating Hours",
    social_title: "Social Media & Website",
    social_desc: "Displayed as buttons on the public profile sidebar · min 1, max 6.",
    btn_add_link: "Add link",
    preview_title: "Public Profile Preview",
    preview_subtitle: "SOCIAL MEDIA",
    badge_verified: "Verified",
    badge_valid: "valid",
    badge_optional: "optional",
    empty_links: "No valid links yet...",
  },
  Product: {
    title: "Products & Services",
    subtitle_total: "Total",
    subtitle_products: "products -",
    subtitle_slots: "slots left",
    btn_create: "Create New Product",
    status_live: "Live",
    desc_live: "visible to public",
    status_pending: "Pending Review",
    desc_pending: "waiting for admin",
    status_revision: "Needs Revision",
    desc_revision: "action required",
    status_draft: "Draft / Inactive",
    desc_draft: "not submitted yet",
    tab_all: "All",
    tab_live: "Live",
    tab_pending: "Pending",
    tab_revision: "Revision",
    tab_draft: "Draft",
    search_placeholder: "Search product...",
    sort_label: "Sort by:",
    sort_newest: "Newest",
    sort_oldest: "Oldest",
    th_product: "PRODUCT",
    th_status: "STATUS",
    th_price: "PRICE",
    th_rating: "RATING",
    th_view: "VIEW / CLICK",
    th_update: "UPDATE",
    action_edit: "Edit",
    action_view: "View",
    action_fix: "Fix",
    action_continue: "Continue",
    btn_prev: "Previous",
    btn_next: "Next",
    pagination_showing: "Showing",
    pagination_of: "of"
  },
  ProductDetail: {
    title: "Product Detail",
    description: "Complete preview of your product information and service packages.",
    loading: "Loading product details...",
    starts_from: "Starts from ",
    estimation: "Estimated duration:",
    primary: "Primary",
    description_title: "Description",
    included: "Included",
    excluded: "Excluded",
    btn_close: "Close",
  },
  ProductTable: {
    col_product: "Product",
    col_status: "Status",
    col_price: "Price",
    col_update: "Update",
    btn_view: "View",
    empty_title: "No products yet",
    empty_desc: "Product data not found or has not been created.",
    working_days: "working days",
    no_estimation: "Estimation not set",
    btn_edit: "Edit Product",
    btn_delete: "Delete",
  },
  Review: {
    title: "Client Reviews",
    subtitle: "Reply to reviews to build trust with new clients. Max 1 reply per review.",
    rating_active: "active reviews",
    dist_title: "Rating Distribution",
    filter_title: "Filter",
    filter_unreplied: "Unreplied",
    filter_5star: "5★ only",
    filter_3star_below: "≤ 3★ (needs attention)",
    filter_has_photo: "Has photo proof",
    filter_reported: "Reported",
    tab_all: "All",
    tab_unreplied: "Unreplied",
    tab_1to3: "1-3★",
    sort_label: "Sort by:",
    sort_newest: "Newest",
    sort_oldest: "Oldest",
    verified_client: "verified client",
    on_package: "on",
    reply_title: "YOUR REPLY",
    replied_on: "Replied on",
    btn_edit: "Edit",
    reply_form_title: "Reply to this review",
    reply_form_limit: "(max 1 reply)",
    reply_placeholder: "Write your reply — express gratitude, clarify, or apologize if necessary...",
    btn_report: "Report review",
    btn_later: "Later",
    btn_send: "Send reply",
    reported_badge: "Reported",
    report_status: "Report status:",
    report_waiting: "Waiting for admin decision",
    reported_on: "Reported on",
    report_reason: "reason:",
    load_more: "Load {count} more reviews ↓",
    report_status_title: "Review Under Admin Review",
    report_reason_label: "Report reason:",
    reply_later_msg: "You marked this review to reply later.",
    reply_now_btn: "Write reply now",
  },
  Analytics: {
    title: "Analytics",
    subtitle: "Only showing your own data · aggregated & anonymous",
    btn_export: "Export CSV",
    filter_7d: "7 days",
    filter_30d: "30 days",
    filter_3m: "3 months",
    filter_1y: "This year",
    score_pageview: "Total Pageviews",
    score_click: "Contact Clicks",
    score_visitor: "Unique Visitors",
    score_conversion: "Conversion to Contact",
    from_last_period: "from last period",
    chart_traffic: "Profile Traffic — 30 Days",
    chart_breakdown: "Contact Click Breakdown",
    legend_pageview: "Pageview",
    legend_click: "Contact Click",
    list_products: "Most Viewed Products",
    list_sources: "Traffic Sources",
    th_user: "USER",
    th_product: "PRODUCT",
    th_type: "TYPE",
    th_time: "TIME",
    table_title: "Recent Contact Clicks",
    table_subtitle: "Users who clicked the Contact button · saved for analytics",
    btn_view_all: "View all {count} clicks →"
  },
  VendorSettingsPage: {
    title: "Account",
    subtitle: "Login email settings & account information",
    menu_akun: "Account",
    menu_keamanan: "Security",
    menu_notifikasi: "Notifications",
    menu_privasi: "Privacy",
    menu_tim: "Team & Access",
    menu_zona: "Danger Zone",
    section_identitas: "Email & Identity",
    lbl_email: "Login Email",
    lbl_phone: "Login Phone Number",
    lbl_lang: "Language",
    lbl_timezone: "Timezone",
    btn_ubah_email: "Change email",
    btn_ubah: "Change",
    badge_verified: "Verified",
    section_keamanan: "Security",
    lbl_password: "Password",
    desc_password: "Last changed 3 months ago",
    btn_ubah_password: "Change password",
    lbl_2fa: "2-Step Verification",
    desc_2fa: "Add security layer via WhatsApp OTP",
    badge_inactive: "Inactive",
    btn_activate: "Activate",
    lbl_session: "Active Sessions",
    desc_session: "3 devices currently logged in",
    btn_manage_session: "Manage sessions",
    section_notif: "Notification Preferences",
    th_jenis: "TYPE",
    notif_1: "Product review results by admin",
    notif_1_desc: "Approve / revise / reject",
    notif_2: "New incoming reviews",
    notif_2_desc: "From clients on your products",
    notif_3: "Grade changes",
    notif_3_desc: "Vendor grade up or down",
    notif_4: "Portfolio reminder",
    notif_4_desc: "Day 20 & 27 since last upload",
    notif_5: "Daily contact digest",
    notif_5_desc: "Daily contact click summary",
    notif_6: "Tips & info from Elynk",
    notif_6_desc: "Promotions, feature updates, education",
    section_zona: "Danger Zone",
    desc_zona: "The actions below are permanent or require coordination with Elynk admins.",
    lbl_pause: "Pause Vendor Account",
    desc_pause: "Profile remains but is hidden from directory. Can be reactivated anytime.",
    btn_pause: "Pause",
    lbl_delete: "Delete Vendor Account",
    desc_delete: "Soft delete - data kept for 90 days before permanent deletion.",
    btn_delete: "Delete account"
  },
  BackgroundBoxForm: {
    tambah_gambar: "Add Image",
    ganti_gambar: "Replace Image",
    hapus_video: "Remove Video",
    tambah_video: "Add Video",
    ganti_video: "Replace Video",
    foto_wajib_untuk_video: "Add a background photo first before using a video",
    simpan_perubahan: "Save Changes",
    modal_ganti_gambar: "Replace Image",
    modal_tambah_gambar: "Add Image",
    modal_tambah_video: "Add Video",
    modal_ganti_video: "Replace Video",
    video_latar: "Background Video",
    video_tersimpan: "Saved videos",
    mulai_menit: "Start (mm:ss)",
    selesai_menit: "End (mm:ss)",
    keterangan_menit: "Example:",
    keterangan_menit_satuan: "= {n} min {s} sec.",
    keterangan_selesai_kosong: "Leave End ({placeholder}) empty to play until the end.",
    gunakan_link: "Use This Link",
    placeholder_youtube: "https://youtube.com/watch?v=...",
    tab_youtube: "YouTube",
    tab_upload: "Upload File",
    drop_video: "Drop video here",
    drag_or_click: "Drag or click to upload video",
    format_video: "MP4, MOV, WebM",
    mengunggah: "Uploading…",
    berhasil_unggah: "Video uploaded — click Save Changes to save",
    gagal_url_video: "Failed to get video URL",
    link_youtube_tidak_valid: "The link you entered is not a valid YouTube link",
    ukuran_video_terlalu_besar: "Video size must not exceed 20MB",
    format_video_tidak_didukung: "Video format is not supported"
  },
  StyleEditor: {
    reset_confirm_title: "Reset This Component's Style?",
    reset_confirm_desc: "Restore the {name} component's style back to default (empty)? Changes you've saved specifically for this component will be removed. Other components won't be affected.",
    reset_confirm_cancel: "Cancel",
    reset_confirm_button: "Yes, Reset",
    reset_loading_button: "Resetting...",
    reset_button: "Reset",
    reset_no_invitation: "Invitation ID not found",
    empty_title: "Style Editor",
    empty_desc: "Click a component area in the preview to start editing its design.",
    label_component: "Component: {name}",
    label_type: "Type: {type}",
    copy_json: "Copy JSON Style",
    save_style: "Save Style",
    save_changes: "Save Changes",
    color_text: "Text Color",
    color_background: "Background Color",
    color_border: "Border Color",
  },
  BoxEditor: {
    slot_saved_as: "The property will be saved as",
    title: "Box Editor",
    undo: "Undo (Ctrl+Z)",
    redo: "Redo (Ctrl+Shift+Z)",
    back_to_editor: "Back to Editor",
    edit_via_json: "Edit via JSON",
    load_json: "Load JSON",
    load_json_title: "Load from JSON",
    global_slider: "Is Slider (Top Level)",
    global_slider_hint: "(Enable slider globally)",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
    done: "Done",
    delete: "Delete",
    deleting: "Deleting...",
    confirm_leave: "Your box changes haven't been saved. Leave anyway?",
    confirm_cancel: "Discard all unsaved box changes?",
    toast_saved: "Box saved successfully",
    toast_save_failed: "Failed to save box",
    layer_title: "Layer",
    layer_hint: "(visibility in preview)",
    layer_overlay: "Overlay",
    layer_overlay_hint: "content",
    layer_ornaments: "Ornaments",
    layer_ornaments_hint: "decoration",
    layer_base: "Base",
    layer_base_hint: "background",
    layer_show: "Show {name}",
    layer_hide: "Hide {name}",
    focus_ornament: "Focus on ornaments",
    focus_ornament_done: "Done editing ornaments",
    show_all: "Show all",
    layer_help: "Click an ornament in the preview to select it, then drag / resize / rotate. Press Esc to deselect.",
    show_in_preview: "Show in preview",
    hide_in_preview: "Hide in preview",
    properties_count: "{count} properties",
    use_images: "Use Images",
    use_images_hint: "(Enable background images array)",
    no_images: "No images yet.",
    image_url_placeholder: "/path/to/image.jpg or full URL",
    add_image_url: "Add Image URL",
    is_slider: "Is Slider",
    is_slider_hint: "(Enable slider for {name})",
    col_property: "Property",
    col_value: "Value",
    no_properties: "No properties yet.",
    add_section: "Add {name}",
    property_placeholder: "property",
    value_placeholder: "value",
    ornaments: "Ornaments",
    items_count: "{count} items",
    no_ornaments: "No ornaments yet.",
    add_ornament: "Add ornament",
    delete_ornament: "Delete ornament",
    selected: "selected",
    styles_count: "{count} styles",
    type: "Type",
    url_path: "URL / path",
    choose_image: "Choose image",
    wrapper_styles: "Wrapper Styles",
    add_style: "Add style",
    no_wrapper_styles: "No wrapper styles yet.",
    element_tree: "Element Tree",
    nodes_count: "{count} nodes",
    selected_node: " • selected {type}",
    add_root_element: "Add root element",
    no_nodes: "No nodes yet. Add a root element, then add children like in the component builder.",
    nodes: "Nodes",
    pick_node: "Select a node on the left to edit its props, styles and child elements.",
    svg_code: "SVG code",
    svg_invalid_prefix: "Must start with",
    svg_invalid_middle: "and end with",
    animation_on: "🎬 animation",
    animation_add: "+ animation",
    preview_animation: "Preview animation",
    node: "Node",
    node_type: "type",
    add_child: "Add Child",
    raw_svg: "Raw SVG",
    raw_svg_hint: "paste <svg>...</svg>",
    raw_svg_note_prefix: "This value is stored in the prop",
    raw_svg_note_suffix: "to be rendered as raw SVG.",
    props: "Props",
    add_prop: "+ prop",
    no_props: "No props yet.",
    key_placeholder: "key",
    styles: "Styles",
    no_styles: "No styles yet.",
    rotate: "Rotate",
    choose_token: "-- choose token --",
    choose_from_media_placeholder: "Choose from media...",
    free_value_placeholder: "free value...",
    switch_to_text: "Switch to free text",
    switch_to_token: "Switch to token",
    choose_from_media: "Choose from media",
    json_title: "Load JSON Structure",
    json_desc_prefix: "Paste",
    json_desc_suffix: "from the API to load it into the editor.",
    format: "Format",
    clear: "Clear",
    json_stats: "{lines} lines · {chars} chars",
    json_placeholder: "Enter JSON here...",
    json_loaded: "JSON loaded into the editor!",
    load_to_editor: "Load into Editor",
    json_must_be_object: "JSON must be an object, not an array.",
    json_invalid: "Invalid JSON.",
    json_format_failed: "Can't format — invalid JSON.",
    anim_title: "Node Animation",
    anim_choose_style: "Choose Animation Style",
    preview: "Preview",
    replay: "▶ Replay",
    duration: "Duration",
    easing: "Motion style",
    anim_pick_hint: "Choose one of the animation styles above to continue",
    remove_animation: "Remove Animation",
    apply: "Apply",
    ease_smooth: "Smooth",
    ease_fast_start: "Fast start",
    ease_overshoot: "Overshoot",
    ease_bounce: "Bounce",
    ease_elastic: "Elastic",
    ease_sine: "Sine",
    ease_linear: "Linear",
    add_style_title: "Add Style Property",
    tab_preset: "Preset",
    tab_custom: "Custom",
    slot_label: "Part to style",
    custom_hint_prefix: "Enter a CSS property manually (e.g.",
    custom_hint_suffix: "etc.)",
    custom_property_label: "Property (CSS key)",
    custom_property_placeholder: "e.g. letter-spacing",
    default_value: "Default Value",
    custom_value_placeholder: "e.g. 0.05em",
    add_style_button: "+ Add Style",
    search_property: "Search property... (e.g. color, flex, margin)",
    no_matching_property: "No matching property",
    default_label: "default:",
    already_added: "✓ Already added",
    cat_all: "All",
    cat_layout: "Layout",
    cat_background: "Background",
    cat_spacing: "Spacing",
    cat_typography: "Typography",
    cat_border: "Border",
    cat_effects: "Effects",
    cat_animation: "Animation",
    cat_position: "Position",
    cat_special: "Special",
    prop_desc_display: "Element box model type",
    prop_desc_flexDirection: "Flex container axis direction",
    prop_desc_alignItems: "Item position on the cross axis",
    prop_desc_justifyContent: "Item distribution on the main axis",
    prop_desc_width: "Element width",
    prop_desc_height: "Element height",
    prop_desc_minHeight: "Minimum element height",
    prop_desc_overflow: "How overflowing content is shown",
    prop_desc_position: "Element positioning method",
    prop_desc_zIndex: "Element stacking order (layer)",
    prop_desc_top: "Distance from the top edge",
    prop_desc_left: "Distance from the left edge",
    prop_desc_right: "Distance from the right edge",
    prop_desc_bottom: "Distance from the bottom edge",
    prop_desc_background: "Shorthand property for the background",
    prop_desc_backgroundColor: "Background color",
    prop_desc_backgroundImage: "Background image",
    prop_desc_backgroundSize: "Background image display size",
    prop_desc_backgroundPosition: "Background image position",
    prop_desc_margin: "Space outside the element (4 sides)",
    prop_desc_padding: "Space inside the element (4 sides)",
    prop_desc_color: "Text color",
    prop_desc_fontSize: "Font size",
    prop_desc_fontWeight: "Font weight",
    prop_desc_textAlign: "Horizontal text alignment",
    prop_desc_lineHeight: "Space between text lines",
    prop_desc_fontFamily: "Element font / typography",
    prop_desc_borderRadius: "Element corner rounding",
    prop_desc_border: "Element border line",
    prop_desc_boxShadow: "Element shadow",
    prop_desc_opacity: "Transparency level",
    prop_desc_transform: "Rotate, scale, translate",
    prop_desc_transition: "Property change animation",
    prop_desc_animation: "CSS keyframe animation",
    prop_desc_contain: "Background image doesn't overflow, produces background-size: contain",
    remove_token: "Remove token",
    use_token: "Use token {token}",
    side_top: "Top",
    side_right: "Right",
    side_bottom: "Bottom",
    side_left: "Left",
    anim_custom: "Custom",
    choose_animation: "Choose Animation",
    animation_placeholder: "e.g. smoothSwing 5.5s infinite ease-in-out",
    select_placeholder: "Select...",
    font_theme: "Theme",
    font_heading: "Heading",
    font_sub: "Sub",
    font_description: "Description",
    bg_solid: "Solid color",
    bg_linear: "Linear gradient",
    bg_radial: "Radial gradient",
    bg_image: "Image",
    bg_angle: "Angle",
    bg_color_stops: "Color stops",
    bg_add_stop: "Add stop",
    bg_shape: "Shape",
    bg_color: "Color",
    bg_url: "URL",
    bg_size: "Size",
    bg_position: "Position",
    bg_repeat: "Repeat",
    move_up: "Move up",
    move_down: "Move down",
    delete_layer: "Delete layer",
    no_layers: "No layers yet. Add a gradient or image above.",
    close_editor: "Close editor",
    edit_background: "Edit background",
    set_background: "Set background",
    theme_color_variables: "Theme Color Variables",
    pick_color: "Pick Color",
    default: "Default",
    color_primary: "Primary",
    color_secondary: "Secondary",
    color_heading: "Heading",
    color_paragraph: "Paragraph",
    color_other: "Other",
    media_title: "Choose Media",
    ornament_tab: "Ornament",
    upload_ornament: "Upload Ornament",
    upload_ornament_title: "Upload Ornament Media",
    media_label: "Media",
    drop_here: "Drop the file here ...",
    drag_or_click: "Drag & drop an image here, or click to select one",
    media_name: "Media Name",
    uploading: "Uploading...",
    upload: "Upload",
    invalid_file_type: "Only .jpg, .jpeg, .png, .gif and .webp are supported.",
    media_name_required: "Media name is required.",
    media_name_too_long: "Media name can't exceed 255 characters.",
    search_ornament: "Search ornaments...",
    clear_search: "Clear search",
    delete_item: "Delete {name}",
    ornament_load_failed: "Failed to load ornament media.",
    ornament_not_found: "No ornament media found.",
    all_media_loaded: "All media loaded.",
    pick: "Choose",
    delete_media_title: "Delete Ornament Media",
    delete_media_confirm_prefix: "Are you sure you want to delete",
    toast_upload_ok: "Ornament media uploaded successfully",
    toast_upload_failed: "Failed to upload ornament media",
    toast_delete_ok: "Ornament media deleted successfully",
    toast_delete_failed: "Failed to delete ornament media",
  },
}

export default en